import { buildPuzzle } from '@rendever/puzzle-core/crossword';
const FULL_ATTRIBUTION = 'Full-size (11×11) crossword built with tools/crossword-build: symmetric grid ' +
    'generator + bitset/cross-mask fill engine; fill from Spread the Word(list) ' +
    '(CC BY-NC-SA 4.0; puzzle sellable, list not redistributed) ∩ ENABLE (public ' +
    'domain); hand-curated for clean fill; clues authored by hand. ' +
    'Difficulty via wordfreq (Apache-2.0).';
/* ========================================================================== *
 *  The shipping 11×11s. Grades: easy = mostly everyday answers; medium = a few
 *  fair-but-advanced words; hard = solidly fair vocabulary, a touch more reach.
 * ========================================================================== */
// full-0001 — "Morning Cup" (18 blocks)
const FULL_0001 = buildPuzzle({
    id: 'full-0001',
    size: 'full',
    difficulty: 'medium',
    layout: ['MARSH#WAFTS', 'ACUTE#AFORE', 'REBAR#STRAP', '###FOR#EMIT', 'COFFEE#RULE', 'AVE#SEE#LET', 'REDS#KNEADS', 'AREA#SON###', 'MARCH#UTTER', 'BLARE#GRAVE', 'ALLAY#HYPED'],
    title: 'Morning Cup',
    clues: {
        '1A': 'Boggy ground where reeds grow',
        '6A': 'Drifts gently on the breeze, as a scent',
        '11A': 'Sharp, as a sense of hearing',
        '12A': 'Before, in old-fashioned verse',
        '13A': 'Steel rod set in concrete for strength',
        '14A': 'Belt or shoulder band',
        '15A': 'On behalf of',
        '17A': 'Send out, as light or heat',
        '18A': 'Brewed pick-me-up for the morning',
        '21A': 'Govern, or a measuring stick',
        '22A': 'Lane, on a street sign (abbr.)',
        '23A': 'Take a look',
        '25A': 'Permit, or a hindrance in tennis',
        '26A': 'Crimson shades',
        '28A': 'Works the dough by hand',
        '30A': 'Region or neighbourhood',
        '31A': 'A boy of the family',
        '32A': 'Springtime month',
        '34A': 'Say plainly',
        '38A': 'Sound off loudly, as a horn',
        '39A': 'Solemn and serious',
        '40A': 'Soothe or calm, as fears',
        '41A': 'All worked up, in slang',
        '1D': 'Damage, as a smooth finish',
        '2D': 'Playing card just above the two',
        '3D': 'Give a quick massage to',
        '4D': 'The workers, collectively',
        '5D': 'Brave figures of legend',
        '6D': 'Used to be',
        '7D': 'Following, in time',
        '8D': 'The recipe for a thing',
        '9D': 'Followed along behind',
        '10D': 'Groups of seven musicians',
        '16D': 'Gives off a strong smell',
        '18D': 'Goodness gracious!, south of the border',
        '19D': 'On the whole; taken together',
        '20D': 'Run by the government',
        '24D': 'More than plenty',
        '27D': 'Holy bones, to a scholar',
        '29D': 'Way into a building',
        '33D': 'Greeting to get attention',
        '35D': 'Gentle pat or faucet',
        '36D': 'The night before a holiday',
        '37D': 'Cardinal colour',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0002 — "Word to the Wise" (18 blocks)
const FULL_0002 = buildPuzzle({
    id: 'full-0002',
    size: 'full',
    difficulty: 'medium',
    layout: ['HUMAN#ROTOR', 'ANISE#ABODE', 'LICKS#GLIDE', 'FOR#TOTALED', '#NOT#WATERY', '###RANGE###', 'STRIVE#SEE#', 'PROVERB#VET', 'RIVER#UTERI', 'ABETS#GENIE', 'TERSE#SATES'],
    title: 'Word to the Wise',
    clues: {
        '1A': 'You, me, and everyone else',
        '6A': 'Spinning blade atop a helicopter',
        '11A': 'Licorice-flavoured seed',
        '12A': 'A dwelling place',
        '13A': 'Quick tongue strokes, as an ice cream cone gets',
        '14A': 'Sail along smoothly through the air',
        '15A': 'On behalf of',
        '16A': 'Added right up',
        '18A': 'The opposite of yes',
        '20A': 'Thin and runny, like weak soup',
        '21A': 'Mountain chain, or a kitchen stove',
        '23A': 'Try hard and push on',
        '26A': 'Catch sight of',
        '29A': 'A short, wise saying',
        '31A': 'Animal doctor, for short',
        '33A': 'Flowing water, like the Thames',
        '34A': 'Wombs, in medical terms',
        '36A': 'Helps along, often in mischief',
        '37A': 'Wish-granting spirit of the lamp',
        '38A': 'Short and to the point',
        '39A': 'Fills up fully, as a big meal does',
        '1D': 'Fifty percent',
        '2D': 'Joining together, as of workers',
        '3D': 'Very small, as a tiny chip',
        '4D': 'Request, or pose a question',
        '5D': 'Cosy spot for a bird',
        '6D': 'Ragged and shabby band',
        '7D': 'Flat round wafers of communion bread',
        '8D': 'Painted canvas for a chair seat, in old fabric terms',
        '9D': 'Stranger, or more peculiar',
        '10D': 'Like a marsh full of tall grass',
        '17D': 'Holder of the deed to a house',
        '19D': 'Three-legged stands for hot pots',
        '22D': 'Strongly opposed and unwilling',
        '23D': 'Small herring-like fish',
        '24D': 'A family or a folk grouping',
        '25D': 'One who wanders far and wide',
        '27D': 'A happening or occasion',
        '28D': 'Spooky and strange',
        '30D': 'Pesky insects at a picnic',
        '32D': 'Knots a shoelace, say',
        '35D': 'Afternoon drink in Britain',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0003 — "On Reflection" (18 blocks)
const FULL_0003 = buildPuzzle({
    id: 'full-0003',
    size: 'full',
    difficulty: 'hard',
    layout: ['#BEAT#RENAL', 'BRAVE#EVADE', 'LATEN#TIBIA', 'OVER#HALOES', 'WORSHIP#BUT', '###EARED###', 'FED#RESERVE', 'AROUND#MEAL', 'CAUSE#TELLS', 'ESSES#WAIVE', 'DEEDS#ONCE#'],
    title: 'On Reflection',
    clues: {
        '1A': 'Steady rhythm of a drum',
        '5A': 'Having to do with the kidneys',
        '10A': 'Bold and fearless',
        '11A': 'Slip away from, as a question',
        '12A': 'Grow late into the evening',
        '13A': 'The shinbone',
        '14A': 'Finished, or above',
        '15A': 'Glowing rings around saints in paintings',
        '16A': 'Bow the head in reverence',
        '18A': 'However; on the other hand',
        '19A': 'Having ears, as some owls appear',
        '21A': 'Looked after, as a hungry crowd',
        '24A': 'Held back for later use',
        '28A': 'In a circle; on every side',
        '30A': 'Breakfast, lunch, or dinner',
        '31A': 'The reason behind something',
        '32A': 'Lets you know; gives away',
        '33A': 'Curving shapes, like the letter at the start of "snake"',
        '34A': 'Give up, as a right or a fee',
        '35A': 'Heroic acts; legal documents',
        '36A': 'A single time',
        '1D': 'Cheer for the matador',
        '2D': 'One who dines',
        '3D': 'Strongly disliking',
        '4D': 'A number after nine',
        '5D': 'Sticks fresh tape on again',
        '6D': 'Wicked; the opposite of good',
        '7D': 'A rich and powerful bigwig',
        '8D': 'Farewell, in French',
        '9D': 'The smallest amount',
        '10D': 'Strike hard, or a setback',
        '15D': 'Took on for a job',
        '17D': 'Set of straps that hitches a horse to a cart',
        '20D': 'Belittle or degrade',
        '21D': 'Looked squarely at; clad, as a wall',
        '22D': 'Rub out a pencil mark',
        '23D': 'Drench with water',
        '25D': 'A treasured old keepsake',
        '26D': 'Flap that controls the flow in a pipe',
        '27D': 'Otherwise; if not',
        '29D': 'Made use of',
        '32D': 'A couple, in number',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0004 — "Cast Iron" (16 blocks)
const FULL_0004 = buildPuzzle({
    id: 'full-0004',
    size: 'full',
    difficulty: 'hard',
    layout: ['KASHA#CORAL', 'ALTOS#EVADE', 'PIERS#MEDIA', 'PEER#SERIES', 'ANDIRON#OUT', '###DELTA###', 'FOR#FISSURE', 'ERASED#SPAN', 'ADDER#CUBIT', 'SEINE#AROSE', 'TRITE#NEWER'],
    title: 'Cast Iron',
    clues: {
        '1A': 'Hearty porridge of buckwheat groats',
        '6A': 'Pinkish-orange reef colour',
        '11A': 'Lower female singing voices',
        '12A': 'Dodge or sidestep',
        '13A': 'Landing platforms that reach into the sea',
        '14A': 'Newspapers, TV, and radio together',
        '15A': 'Look closely, or a lord of the realm',
        '16A': 'A set of episodes in a row',
        '17A': 'Iron support for logs in a fireplace',
        '19A': 'No longer in; not at home',
        '20A': 'Triangular mouth of a river',
        '22A': 'In favour of',
        '25A': 'A narrow crack or split',
        '29A': 'Rubbed clean off the page',
        '31A': 'Reach across, or a length of time',
        '32A': 'A common garden snake',
        '33A': 'Old measure from elbow to fingertip',
        '34A': 'Big fishing net cast from a boat',
        '35A': 'Got up; came about',
        '36A': 'Worn-out and overused',
        '37A': 'More recent',
        '1D': 'Greek letter shaped like a sideways K',
        '2D': 'From another world entirely',
        '3D': 'Noble horse of a knight',
        '4D': 'Frightful and dreadful',
        '5D': 'Donkey, plainly',
        '6D': 'Binds with mortar and a trowel',
        '7D': 'Above, or finished',
        '8D': 'Wireless that brings you music',
        '9D': 'A fond farewell',
        '10D': 'The smallest bit',
        '16D': 'Firm and dependable',
        '18D': 'A neutral judge in a match',
        '21D': 'Promise faithfully; make safe',
        '22D': 'A grand celebratory dinner',
        '23D': 'A command; tidy arrangement',
        '24D': 'Two of a kind, in geometry circles, on a die',
        '26D': 'Bow stroke that pushes up, in violin music',
        '27D': 'Lift the spirits of',
        '28D': 'Walk in, as through a doorway',
        '30D': 'Calendar units of twenty-four hours',
        '33D': 'Tin, on a soup label',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0005 — "Garden Party" (16 blocks)
const FULL_0005 = buildPuzzle({
    id: 'full-0005',
    size: 'full',
    difficulty: 'hard',
    layout: ['ASPIC#PASTA', 'GUANO#ASHEN', 'LARGO#USING', 'OVERLAP#FOR', 'WERE#GENTRY', '###SPARE###', 'BONSAI#URGE', 'EVE#UNCTION', 'GIRLS#ARGOT', 'INDIE#RAISE', 'NESTS#ELDER'],
    title: 'Garden Party',
    clues: {
        '1A': 'Savoury jelly that sets around cold meat',
        '6A': 'Italian noodles of every shape',
        '11A': 'Seabird droppings used to enrich soil',
        '12A': 'Pale, as a frightened face',
        '13A': 'Slow and stately, in music',
        '14A': 'Making use of',
        '15A': 'Cover partly, as roof tiles do',
        '17A': 'In favour of',
        '18A': 'Used to be, in the plural',
        '19A': 'The landed upper class',
        '21A': 'Held in reserve; extra',
        '23A': 'Tiny tree grown in a shallow tray',
        '26A': 'Strong wish or impulse',
        '30A': 'The day before a holiday',
        '31A': 'A soothing or oily smoothness of manner',
        '33A': 'Young females',
        '35A': 'Special slang of a trade or group',
        '36A': 'Small independent film, informally',
        '37A': 'Lift up; bring up, as children',
        '38A': 'Cosy homes for birds',
        '39A': 'Older; a flowering shrub with dark berries',
        '1D': 'Bathed in soft light',
        '2D': 'Smooth and charming in manner',
        '3D': 'Tool that whittles wood thin',
        '4D': 'A way in; an entrance',
        '5D': 'Pleasantly chilly',
        '6D': 'A very poor person',
        '7D': 'Stubborn beast of burden',
        '8D': 'Move workers to a different schedule',
        '9D': 'Singing voice between bass and alto',
        '10D': 'Cross and short-tempered',
        '16D': 'Once more; another time',
        '20D': 'Neither helping nor harming; in the middle',
        '22D': 'Brief stops or breaks',
        '23D': 'Make a start; commence',
        '24D': 'Having to do with sheep',
        '25D': 'Bookish sorts who love a fact',
        '27D': 'Stiff and unbending',
        '28D': 'A large grey waterbird with a long neck',
        '29D': 'Walk in through the door',
        '32D': 'Look after; mind',
        '34D': 'Brightly burning, as a candle',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0006 — "All Steamed Up" (16 blocks)
const FULL_0006 = buildPuzzle({
    id: 'full-0006',
    size: 'full',
    difficulty: 'hard',
    layout: ['SHOUT#STEAM', 'HOUSE#USAGE', 'INTER#RURAL', 'FOR#MAGNETO', 'TREE#DEADEN', '###SPASM###', 'GOSSIP#INTO', 'EXTENTS#OUT', 'SLING#LAITH', 'SINCE#AGREE', 'OPTED#POSER'],
    title: 'All Steamed Up',
    clues: {
        '1A': 'Call out at the top of your voice',
        '6A': 'Vapour that rises from a boiling kettle',
        '11A': 'A home to live in',
        '12A': 'The way a word is normally used',
        '13A': 'Bury, or place between',
        '14A': 'Of the countryside',
        '15A': 'On behalf of',
        '16A': 'Small generator that makes a spark',
        '18A': 'Oak, elm, or maple',
        '20A': 'Dull the force of, as a sound',
        '21A': 'Sudden involuntary twitch',
        '23A': 'Idle chatter about others',
        '26A': 'Heading toward the inside of',
        '30A': 'The sizes or reaches of things',
        '32A': 'Not in; away',
        '33A': 'Loop for carrying an injured arm',
        '34A': 'Willing, in old Scottish speech',
        '36A': 'From a time in the past until now',
        '37A': 'Nod in shared opinion',
        '38A': 'Chose, as from a menu',
        '39A': 'A puzzling question; one who pretends',
        '1D': 'Change of gears; a work period',
        '2D': 'Hold in high regard',
        '3D': 'Far-fetched and odd, from the French',
        '4D': 'Put to work; employ',
        '5D': 'A word for a period or season',
        '6D': 'Sudden rushes forward, as of a crowd',
        '7D': 'Giant ocean wave from an undersea quake',
        '8D': 'Having ears, as some owls look',
        '9D': 'Hard stone, like striped quartz',
        '10D': 'A sweet-tasting orange fruit',
        '17D': 'The very heart of the matter',
        '19D': 'Quietly tapped, as a sonar signal',
        '22D': 'Made suitable; adjusted to fit',
        '23D': 'Plaster ground used to prime a canvas',
        '24D': 'Spring flower of the primrose family',
        '25D': 'A set period of time; a limit',
        '27D': 'A pupil being privately taught',
        '28D': 'A different person',
        '29D': 'Smack lightly with the palm',
        '31D': 'Some time ago',
        '35D': 'A long while back',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0007 — "Afternoon Tea" (18 blocks)
const FULL_0007 = buildPuzzle({
    id: 'full-0007',
    size: 'full',
    difficulty: 'hard',
    layout: ['SHADE#CRIMP', 'HONEY#RACER', 'ANGLE#ADORE', 'FOR#SAVINGS', 'TRY##PAUSES', '###WANTS###', 'OCTAVE##OUT', 'CHATEAU#USE', 'CAPER#SATIN', 'USERS#EVENS', 'REDYE#SERGE'],
    title: 'Afternoon Tea',
    clues: {
        '1A': 'Cool spot under a tree',
        '6A': 'Pinch into small folds, as pastry edges',
        '11A': 'Sweet syrup the bees make',
        '12A': 'One who runs in a race',
        '13A': 'The corner where two lines meet',
        '14A': 'Love dearly',
        '15A': 'On behalf of',
        '16A': 'Money tucked away for later',
        '18A': 'Give it a go',
        '19A': 'Brief rests in the middle of things',
        '20A': 'Wishes for; would like',
        '22A': 'Eight notes of the musical scale',
        '25A': 'Not in; away',
        '28A': 'Grand country house in France',
        '30A': 'Put to work',
        '31A': 'A playful prank, or a small jar herb',
        '32A': 'Smooth fabric with a sheen',
        '34A': 'People who make use of a thing',
        '35A': 'Comes out level, as a tied score',
        '36A': 'Colour the cloth a fresh shade again',
        '37A': 'Sturdy twilled woollen cloth',
        '1D': 'Long pole, as of an arrow or a mine',
        '2D': 'Great respect; a code of conduct',
        '3D': 'Cross and irritable',
        '4D': 'Computer key for removing a letter',
        '5D': 'What you see with',
        '6D': 'Gentleman’s neckcloth, an old-fashioned tie',
        '7D': 'The distance from a circle’s centre to its edge',
        '8D': 'Symbols on a screen you tap to open things',
        '9D': 'Blend or join into one, as two lanes',
        '10D': 'Push firmly; an iron for shirts',
        '17D': 'A pause in breathing during sleep',
        '20D': 'Thin and runny, like weak soup',
        '21D': 'Strongly opposed and unwilling',
        '22D': 'Take place; come about',
        '23D': 'Run after',
        '24D': 'Stuck down, as a parcel',
        '25D': 'Nearer the edge; on the far side',
        '26D': 'Making use of',
        '27D': 'Strained and on edge',
        '29D': 'Makes use of',
        '33D': 'Lane, on a street sign (abbr.)',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0008 — "Slice of Cake" (18 blocks)
const FULL_0008 = buildPuzzle({
    id: 'full-0008',
    size: 'full',
    difficulty: 'hard',
    layout: ['SHAME##PART', 'TODAY#CRIER', 'ANODE#RELAY', 'FOR#SLIVERS', 'FREE#AMIDST', '###RUPEE###', 'GREASE#WARP', 'HIMSELF#SEE', 'OCCUR#RAISE', 'SEERS#ORDER', 'TREE##MEETS'],
    title: 'Slice of Cake',
    clues: {
        '1A': 'A sense of having done wrong',
        '6A': 'A portion or share',
        '10A': 'This very day',
        '11A': 'One who weeps; a town announcer of old',
        '12A': 'The positive terminal of a battery',
        '13A': 'Pass the baton in, as a team race',
        '14A': 'On behalf of',
        '15A': 'Thin little shavings or splinters',
        '17A': 'At no cost',
        '19A': 'In the middle of; surrounded by',
        '20A': 'Indian coin worth a hundred paise',
        '22A': 'Slippery cooking fat',
        '25A': 'Bend out of true shape',
        '29A': 'His own self',
        '31A': 'Catch sight of',
        '32A': 'Take place; happen',
        '33A': 'Lift up high',
        '35A': 'Wise prophets who foretell',
        '36A': 'A tidy arrangement; a command',
        '37A': 'Oak or maple, for instance',
        '38A': 'Comes together with; greets',
        '1D': 'The team and crew of an office',
        '2D': 'Hold dear; worship',
        '3D': 'Angry, or out of one’s mind',
        '4D': 'What you look at the world with',
        '5D': 'A sneak peek of what’s coming',
        '6D': 'Was in pain; felt poorly',
        '7D': 'Pulls up from behind; the back ends',
        '8D': 'A test of nerve and patience',
        '9D': 'Bumpy ride at a fair, perhaps',
        '11D': 'A wrongdoing the law forbids',
        '16D': 'Fold of a jacket collar, where a flower goes',
        '18D': 'A rubbing-out; a clean slate',
        '21D': 'People who make use of a thing',
        '22D': 'A pale spook said to haunt',
        '23D': 'Kitchen tool that presses potatoes soft',
        '24D': 'A host at a show, in brief',
        '26D': 'Off to the left or right of centre',
        '27D': 'Set back to the start again',
        '28D': 'Equals in rank; lords of the realm',
        '30D': 'Starting at; coming out of',
        '34D': 'They exist; the verb of being',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0009 — "Concert Hall" (18 blocks)
const FULL_0009 = buildPuzzle({
    id: 'full-0009',
    size: 'full',
    difficulty: 'hard',
    layout: ['SCROLL#CAMP', 'TEEPEE#USER', 'ALBEIT#PILE', 'FLANS##ODDS', 'FOR#USELESS', '###ARENA###', 'BETWEEN#SHE', 'AREA##OFTEN', 'SOAK#ABROAD', 'IDLE#CLEAVE', 'LESS#TEETER'],
    title: 'Concert Hall',
    clues: {
        '1A': 'Rolled-up sheet of parchment',
        '7A': 'Pitch your tent and stay the night',
        '11A': 'Cone-shaped tent of the plains',
        '12A': 'One who works at a keyboard',
        '13A': 'Even though; granted that',
        '14A': 'A neat stack or heap',
        '15A': 'Baked custard tarts',
        '16A': 'The chances, for and against',
        '17A': 'On behalf of',
        '18A': 'Of no help at all',
        '21A': 'A ring or stadium for a show',
        '22A': 'In the gap separating two things',
        '25A': 'That woman',
        '28A': 'A region or zone',
        '29A': 'Many a time; frequently',
        '31A': 'Let it sit in water for a good while',
        '32A': 'In a foreign land, across the sea',
        '33A': 'Doing nothing; at rest',
        '34A': 'Split apart cleanly; or cling tightly',
        '35A': 'Not as much',
        '36A': 'Wobble back and forth on the brink',
        '1D': 'The team and crew of an office',
        '2D': 'Large stringed instrument held upright',
        '3D': 'Steel rod set in concrete for strength',
        '4D': 'Not shut',
        '5D': 'Free time for rest and pleasure',
        '6D': 'Allow; permit',
        '7D': 'Small domed roof atop a building',
        '8D': 'Off to one side, out of the way',
        '9D': 'Blends together, as a card player’s hand',
        '10D': 'Push firmly down',
        '19D': 'Catch sight of',
        '20D': 'Raise to a position of honour',
        '21D': 'Stirs from sleep',
        '22D': 'Fragrant herb for tomato sauce',
        '23D': 'Wear away little by little, as water on rock',
        '24D': 'Small ducks of the marshes',
        '25D': 'Small weasel with a white winter coat',
        '26D': 'Lift up, as a heavy sigh',
        '27D': 'One who brings up the rear',
        '30D': 'At no cost',
        '32D': 'A play, or a deed',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0010 — "Looking Glass" (18 blocks)
const FULL_0010 = buildPuzzle({
    id: 'full-0010',
    size: 'full',
    difficulty: 'hard',
    layout: ['GLARE#INAPT', 'RAVEN#NOBLE', 'ITEMS#CROUP', 'THROUGH#USE', 'SETTEE##THE', '###EDEMA###', 'BUT##SIDLES', 'ONE#SERVICE', 'ADDLE#RIFLE', 'SEDAN#OCTAD', 'TRYST#RESTS'],
    title: 'Looking Glass',
    clues: {
        '1A': 'Harsh, dazzling light',
        '6A': 'Out of place; not fitting',
        '11A': 'Glossy black bird of the crow family',
        '12A': 'Grand and dignified',
        '13A': 'Things on a shopping list',
        '14A': 'Barking cough that troubles young children',
        '15A': 'From one end to the other',
        '17A': 'Put to work',
        '18A': 'A small sofa for two',
        '19A': 'Most common word in English, before a noun',
        '20A': 'Swelling from fluid under the skin',
        '23A': 'However; on the other hand',
        '26A': 'Edges along sideways, quietly',
        '30A': 'The number after zero',
        '31A': 'Help given to a customer',
        '32A': 'Muddle or confuse',
        '34A': 'A long gun for hunting',
        '35A': 'A roomy four-door car',
        '36A': 'A group of eight',
        '37A': 'A secret meeting between sweethearts',
        '38A': 'Pauses to catch your breath',
        '1D': 'Coarsely ground corn, a Southern dish',
        '2D': 'Spinning tool that shapes wood',
        '3D': 'Turn aside; head off, as trouble',
        '4D': 'Far off; the TV channel-changer',
        '5D': 'Followed naturally; came after',
        '6D': 'An old measure, the length of a thumb',
        '7D': 'And not; neither this',
        '8D': 'On the subject of; roughly',
        '9D': 'Soft and luxurious, like velvet',
        '10D': 'Cone-shaped tent of the plains',
        '16D': 'Honking birds that fly in a V',
        '21D': 'The looking glass on the wall',
        '22D': 'Helpful guidance you might ask for',
        '23D': 'Brag about; show off',
        '24D': 'Below; beneath',
        '25D': 'A child’s cuddly stuffed bear',
        '27D': 'Raises up, as heavy weights',
        '28D': 'Dazzling brilliance and flair',
        '29D': 'What you plant to grow flowers',
        '31D': 'Posted off, as a letter',
        '33D': 'Lights, on a Spanish sign',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0011 — "Bold Venture" (18 blocks)
const FULL_0011 = buildPuzzle({
    id: 'full-0011',
    size: 'full',
    difficulty: 'easy',
    layout: ['#CAVE#VISTA', 'RAGES#ANNUL', 'INERT#SKATE', 'CONTACT#FOR', 'ENTITY#HURT', '###GECKO###', 'INTO#LISTEN', 'SEE#VENTURE', 'SENSE#DINES', 'UDDER#ELECT', 'ESSAY#REST#'],
    title: 'Bold Venture',
    clues: {
        '1A': 'Where the bats and bears sleep',
        '5A': 'A sweeping view',
        '10A': 'Storms about angrily',
        '11A': 'Declare null and void',
        '12A': 'Lifeless and dull; without energy',
        '13A': 'Glide on the ice',
        '14A': 'Get in touch with',
        '16A': 'In favor of',
        '17A': 'A thing that exists',
        '18A': 'In pain',
        '19A': 'Little wall-climbing lizard',
        '21A': 'Heading toward the inside',
        '24A': 'Lend an ear',
        '28A': 'Take a look',
        '29A': 'A bold undertaking',
        '30A': 'Good judgment; "common ___"',
        '32A': 'Has a fine supper',
        '33A': 'Where the milk comes from',
        '34A': 'Choose at the ballot box',
        '35A': 'A short written composition',
        '36A': 'Take a breather',
        '1D': 'A respected rule or a body of sacred law',
        '2D': 'A spy, or someone who acts on your behalf',
        '3D': 'A dizzy spell',
        '4D': 'A grand property with grounds',
        '5D': 'Stretching far and wide',
        '6D': 'What fills a fountain pen',
        '7D': 'A grand mix-up, in old Army slang',
        '8D': 'A pupil’s private teacher',
        '9D': 'Watchful and ready for action',
        '10D': 'What gets thrown at weddings',
        '15D': 'A repeating round',
        '18D': 'Anything but friendly',
        '20D': 'More gentle',
        '21D': 'A matter or topic up for discussion',
        '22D': 'Must-haves',
        '23D': 'Looks after',
        '25D': 'Songs you can hum along to',
        '26D': 'Stand up straight and tall',
        '27D': 'A cozy home built by a bird',
        '29D': 'To a high degree',
        '31D': 'The salty blue expanse',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0012 — "Simply Elegant" (18 blocks)
const FULL_0012 = buildPuzzle({
    id: 'full-0012',
    size: 'full',
    difficulty: 'easy',
    layout: ['SCARE##TWIN', 'TODAY#CRANE', 'ALONE#HASTE', 'FOR#SHIFTED', 'FREE#INFERS', '###LANAI###', 'ASPECT#CAPS', 'LARGISH#BUT', 'ILIAD#AIOLI', 'EVENS#HOUSE', 'NEST##ANTES'],
    title: 'Simply Elegant',
    clues: {
        '1A': 'Give a fright',
        '6A': 'One of a look-alike pair',
        '10A': 'This very day',
        '11A': 'Tall bird that stands one-legged in the shallows',
        '12A': 'With no company',
        '13A': 'A great rush and hurry',
        '14A': 'On behalf of',
        '15A': 'Moved over',
        '17A': 'At no cost',
        '19A': 'Reads between the lines',
        '20A': 'Open Hawaiian porch or veranda',
        '22A': 'One side of the matter',
        '25A': 'Baseball headwear',
        '29A': 'On the big side',
        '31A': 'On the other hand…',
        '32A': 'Homer’s epic of Troy',
        '33A': 'Garlic mayonnaise spread',
        '35A': 'Numbers like two, four, and six',
        '36A': 'Where you live',
        '37A': 'A bird\'s cozy home for its eggs',
        '38A': 'Chips paid before the deal',
        '1D': 'The workers, collectively',
        '2D': 'What crayons add',
        '3D': 'Love dearly; cherish',
        '4D': 'Went on foot, quickly',
        '5D': 'A pair of peepers',
        '6D': 'Cars crowding the road',
        '7D': 'Fritter away',
        '8D': 'Bury, as a body laid to rest',
        '9D': 'Must-haves',
        '11D': 'The good dishes',
        '16D': 'Small clues that nudge you along',
        '18D': 'Graceful and refined',
        '21D': 'Sour substances, like lemon juice or vinegar',
        '22D': 'From another world entirely',
        '23D': 'Soothing ointment for the skin',
        '24D': 'Levers open; noses in',
        '26D': 'Roughly; approximately',
        '27D': 'The thump you feel at your wrist',
        '28D': 'Pig pens',
        '30D': 'Sound of cheerful laughter',
        '34D': 'A charged particle',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0013 — "Golden Fleece" (18 blocks)
const FULL_0013 = buildPuzzle({
    id: 'full-0013',
    size: 'full',
    difficulty: 'easy',
    layout: ['SWAMP#BARGE', 'CAROL#UNION', 'ULTRA#TIDED', 'FLEECE#MESS', 'FOR#ELSE###', 'SPY#BIT#BAG', '###VOTE#ILL', 'DONE#ERRATA', 'IVORY#NOSES', 'SENSE#USERS', 'CREEP#MESSY'],
    title: 'Golden Fleece',
    clues: {
        '1A': 'Boggy lowland; overwhelm',
        '6A': 'Flat river freight boat; push rudely (in)',
        '11A': 'A merry Christmas song',
        '12A': 'A joining together; a labor ___',
        '13A': 'Extreme; far beyond the ordinary',
        '14A': 'Got through hard times, as one \'over\' a rough spell',
        '15A': 'A sheep’s coat',
        '17A': 'An untidy heap or a jumbled situation',
        '18A': 'On behalf of; in favor of',
        '19A': 'Or ___ (if not)',
        '21A': 'Cloak-and-dagger agent',
        '22A': 'A little piece',
        '23A': 'A grocery sack',
        '26A': 'Have your say at the polls',
        '27A': 'Under the weather',
        '28A': 'Finished and over with',
        '31A': 'A book’s listed corrections',
        '33A': 'Creamy white material from elephant tusks',
        '35A': 'They get counted for attendance',
        '36A': 'Feeling in your bones',
        '37A': 'People who make use of a thing',
        '38A': 'Move slowly and quietly, low to the ground',
        '39A': 'Needing a good tidying',
        '1D': 'Marks up, as shoe toes',
        '2D': 'A mighty blow',
        '3D': 'A major blood vessel; a main road',
        '4D': 'A greater amount; not less',
        '5D': 'The sugar pill in a drug trial',
        '6D': 'However; on the contrary',
        '7D': 'Japanese-style cartoons',
        '8D': 'A spin in the car',
        '9D': 'Departs',
        '10D': 'Where a story finishes',
        '16D': 'The chosen few at the top',
        '20D': 'The breastbone',
        '23D': 'Leanings that cloud judgment',
        '24D': 'Makes changes to',
        '25D': 'Smooth as a mirror, as a lake',
        '26D': 'Lines of a poem set in rhythm',
        '28D': 'A phonograph record, for one',
        '29D': 'Done; finished, as in "all ___"',
        '30D': 'Not a single one',
        '32D': 'The flower of Valentine’s Day',
        '34D': 'Casual yes',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0014 — "Number Games" (18 blocks)
const FULL_0014 = buildPuzzle({
    id: 'full-0014',
    size: 'full',
    difficulty: 'easy',
    layout: ['GUESS#SLUMP', 'ONSET#EERIE', 'OTTER#EAGLE', 'GRADES#FELL', 'OUT#THEY###', 'LEE#CON#RAM', '###THAT#EVE', 'FILE#LITTER', 'ADIEU#THONG', 'LEFTS#LARGE', 'LATHE#ENTER'],
    title: 'Number Games',
    clues: {
        '1A': 'Take a stab at it',
        '6A': 'A batter\'s dry spell',
        '11A': 'The start of something; "___ of war"',
        '12A': 'Spooky and strange, as an old house at night',
        '13A': 'Furry animal that floats on its back and cracks shells',
        '14A': 'Majestic bird and symbol of America',
        '15A': 'What report cards report',
        '17A': 'Took a tumble',
        '18A': 'Not in; stepped ___',
        '19A': 'The folks over there, not us',
        '21A': 'The sheltered side, away from the wind',
        '22A': 'Swindle; the "against" side',
        '23A': 'A male sheep',
        '26A': '"___ one, please" (pointing it out)',
        '27A': 'The night before a holiday',
        '28A': 'A folder\'s home in the cabinet; a nail smoother',
        '31A': 'A batch of new puppies',
        '33A': 'Fond farewell, borrowed from French',
        '35A': 'Sandal held on by a strap between the toes',
        '36A': 'Turns the driver signals for',
        '37A': 'Roomy, as a shirt size',
        '38A': 'Spinning wheel that shapes a clay pot',
        '39A': 'Come in',
        '1D': 'The number 1 followed by a hundred zeros',
        '2D': 'Contrary to fact',
        '3D': 'A grand property with grounds',
        '4D': 'You plant it to grow a flower',
        '5D': 'A good long reach at waking',
        '6D': 'Lay eyes on',
        '7D': 'Full of greenery, like a summer tree',
        '8D': 'A strong wish or impulse',
        '9D': 'Where grain becomes flour',
        '10D': 'What the banana slips out of',
        '16D': 'A shallow sandbar; a school of fish',
        '20D': 'Give the right to',
        '23D': 'A sharp comeback',
        '24D': 'Settle the score for',
        '25D': 'Two companies becoming one',
        '26D': 'What the dentist counts',
        '28D': 'The season of raking',
        '29D': 'A bright thought',
        '30D': 'Hoist, as a heavy box',
        '32D': 'Word used when comparing, as in \'better ___\'',
        '34D': 'Put something to work for a purpose',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0015 — "Hidden Talent" (18 blocks)
const FULL_0015 = buildPuzzle({
    id: 'full-0015',
    size: 'full',
    difficulty: 'easy',
    layout: ['SWAMP#ULCER', 'CAROL#SOAVE', 'ULTRA#EASEL', 'FLEECE#DENY', 'FOR#AXIS###', 'SPY#TEN#SHE', '###TERM#VIA', 'FISH#TALENT', 'ANTES#TILDE', 'SCARE#ENTER', 'THREE#SEERS'],
    title: 'Hidden Talent',
    clues: {
        '1A': 'Boggy lowland; overwhelm',
        '6A': 'A painful open sore',
        '11A': 'A merry Christmas song',
        '12A': 'A crisp, dry Italian white wine',
        '13A': 'Extreme; far beyond the ordinary',
        '14A': 'What holds the painter\'s canvas',
        '15A': 'A sheep’s coat',
        '17A': 'Say no; refuse to admit',
        '18A': 'In support of; not against',
        '19A': 'The line a wheel turns on',
        '21A': 'Cloak-and-dagger agent',
        '22A': 'One more than nine',
        '23A': 'A lady',
        '26A': 'A word, or the length of a school semester',
        '27A': 'By way of; passing through',
        '28A': 'What the angler is after',
        '31A': 'A natural gift',
        '33A': 'Chips paid before the deal',
        '35A': 'Squiggly accent mark over the Spanish n',
        '36A': 'Give a fright',
        '37A': 'Walk through the door',
        '38A': 'A trio in number',
        '39A': 'Wise prophets who foretell',
        '1D': 'Marks up, as shoe toes',
        '2D': 'A mighty blow',
        '3D': 'A major blood vessel; a main road',
        '4D': 'Additional, beyond what\'s there',
        '5D': 'Soothe an angry mood',
        '6D': 'Make practical of a tool',
        '7D': 'Heaps and heaps',
        '8D': 'A detective\'s assignment',
        '9D': 'Level, or on a par',
        '10D': 'Count on; depend upon',
        '16D': 'Put forth effort; apply, as force',
        '20D': 'Those serving time',
        '23D': 'Slender and graceful',
        '24D': 'Get in the way of',
        '25D': 'Everyone at the table',
        '26D': 'In that spot, not here',
        '28D': 'Quick as a wink',
        '29D': 'A foot, in number, has twelve of these',
        '30D': 'Twinkler in the night sky',
        '32D': 'A drawn-out straight mark',
        '34D': 'Catch sight of',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0016 — "Gentleman Caller" (18 blocks)
const FULL_0016 = buildPuzzle({
    id: 'full-0016',
    size: 'full',
    difficulty: 'easy',
    layout: ['SUITOR#MAST', 'UNDONE#AREA', 'STYLED#LENS', 'HILL##FEAST', 'ILLEGAL#SEE', '###DARED###', 'FOR#MEDICAL', 'ELATE##SOLE', 'VICE#REMADE', 'EVEN#ERASER', 'REST#PALTRY'],
    title: 'Gentleman Caller',
    clues: {
        '1A': 'A gentleman caller',
        '7A': 'Ship’s pole that holds the sails',
        '11A': 'Still left to finish',
        '12A': 'A region or open space',
        '13A': 'Given a fresh look at the salon',
        '14A': 'Glass piece in eyeglasses or a camera',
        '15A': 'What Jack and Jill went up',
        '16A': 'A big holiday meal',
        '17A': 'Against the law',
        '20A': 'Take a peek',
        '21A': 'Had the nerve',
        '23A': 'Word meaning "in place of" in a trade',
        '26A': 'Having to do with doctors\' work',
        '30A': 'To fill with great joy',
        '32A': 'Only one, all by itself',
        '33A': 'A bad habit or fault',
        '34A': 'Built all over again',
        '36A': 'Numbers like two, four, and six',
        '37A': 'The pink end of a pencil',
        '38A': 'What you do after a long day',
        '39A': 'Next to nothing, as a sum',
        '1D': 'Japanese fare with rice and seaweed',
        '2D': 'Up to the time of; not before',
        '3D': 'A peaceful, charming country scene',
        '4D': 'Rang slowly, as a church bell',
        '5D': 'The loneliest number',
        '6D': 'A stop light’s color',
        '7D': 'A buck or a rooster, for instance',
        '8D': 'Open spaces or fields of study',
        '9D': 'Sound judgment, or one of the body\'s five',
        '10D': 'Flavor on the tongue',
        '16D': 'Ran for it',
        '18D': 'Checkers or charades',
        '19D': '"Here we ___"',
        '22D': 'Gray and gloomy',
        '23D': 'What a thermometer confirms',
        '24D': 'Green fruit pressed for oil',
        '25D': 'Derbies and dashes',
        '27D': 'Where the land meets the sea',
        '28D': 'Streamside tree of the birch family',
        '29D': 'Wary and doubtful',
        '31D': 'Canvas shelter used while camping',
        '34D': 'A salesperson, for short',
        '35D': 'A long period of history',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0017 — "Melon Patch" (18 blocks)
const FULL_0017 = buildPuzzle({
    id: 'full-0017',
    size: 'full',
    difficulty: 'medium',
    layout: ['GRADS#MAMAS', 'ROBOT#ERASE', 'AGATE#LAPSE', 'BUT#PROBLEM', 'SEE##INLETS', '###PASSE###', 'ASSUME##FOR', 'IMPRESS#ARE', 'REIGN#HOLDS', 'EARED#ONSET', 'DRESS#PEERS'],
    title: 'Melon Patch',
    clues: {
        '1A': 'June\'s cap-and-gown crowd, for short',
        '6A': 'The ones the babies call for',
        '11A': 'A mechanical worker',
        '12A': 'Rub out a pencil mark',
        '13A': 'Hard stone, like striped quartz',
        '14A': 'A slip of memory',
        '15A': 'However; on the other hand',
        '16A': 'A puzzle needing a solution',
        '18A': '"Wait and ___"',
        '19A': 'Little arms of the sea',
        '20A': 'Out of style; old-fashioned',
        '22A': 'Take for granted',
        '25A': 'Word meaning "in favor of"',
        '28A': 'Leave a strong mark on',
        '30A': 'They exist; the verb of being',
        '31A': 'Rule over as a king or queen',
        '32A': 'Keeps a grip on',
        '34A': 'Having handles, as a jug, or able to hear',
        '35A': 'The start of something; "___ of war"',
        '36A': 'Sunday best attire',
        '37A': 'Equals in rank; lords of the realm',
        '1D': '"Up for ___" (free to take)',
        '2D': 'A playful scoundrel up to mischief',
        '3D': 'Die down, as a storm',
        '4D': 'Tiny spot on the page',
        '5D': 'A single stair, or a move forward on foot',
        '6D': 'Cantaloupes and honeydews',
        '7D': 'Fit for the plow',
        '8D': 'Tree the syrup comes from',
        '9D': 'A handy thing of value',
        '10D': 'Gives the impression of being',
        '17D': 'Gets up with the sun',
        '20D': 'Clears out completely',
        '21D': '"Make ___" (set things right)',
        '22D': 'Broadcast over the radio',
        '23D': 'Spread thickly, as butter',
        '24D': 'The steeple\'s point',
        '25D': 'Not true; incorrect',
        '26D': 'Tidy arrangement, or a command in court',
        '27D': 'Takes a breather, with "up"',
        '29D': 'Browse the stores',
        '33D': 'The number after zero',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0018 — "Quiet Minute" (18 blocks)
const FULL_0018 = buildPuzzle({
    id: 'full-0018',
    size: 'full',
    difficulty: 'easy',
    layout: ['BUT#TOP#ASS', 'ANODYNE#BEE', 'STOOPED#AVE', 'TITLE#ANTED', 'ELSE#ALIENS', '###FIRST###', 'MINUTE#PASS', 'ORALS#SINCE', 'RAM#ELECTED', 'ATE#LINKING', 'LED#FED#SEE'],
    title: 'Quiet Minute',
    clues: {
        '1A': '"All ___ one" — that is, except one',
        '4A': 'The highest point',
        '7A': 'A donkey',
        '10A': 'Soothing and inoffensive',
        '12A': 'Buzzing honey-maker',
        '13A': 'Bent with the years',
        '14A': 'Lane, on a street sign (abbr.)',
        '15A': 'A book\'s name',
        '16A': 'Paid into the pot before the deal',
        '18A': 'Or ___ (otherwise)',
        '19A': 'Strangers from another land',
        '20A': 'Coming before all others; number one',
        '22A': 'Sixty seconds; or tiny, said another way',
        '25A': 'Hand along the potatoes',
        '29A': 'Spoken exams',
        '30A': 'From a past time up to now',
        '31A': 'A male sheep',
        '32A': 'Voted into office',
        '34A': 'Had a meal, in past tense',
        '35A': 'Joining together',
        '36A': 'Guided; "she ___ the way"',
        '37A': 'Looked after, as a hungry crowd',
        '38A': 'Have a look',
        '1D': 'Brush a roast with its own juices',
        '2D': 'Right up to the moment of',
        '3D': 'Sounds the horn',
        '4D': 'Sort or kind, as of music',
        '5D': 'The loneliest number',
        '6D': 'What a bicyclist pushes',
        '7D': 'Die down, as a storm',
        '8D': 'Lucky number, some say',
        '9D': 'What you plant to grow flowers',
        '11D': 'Long-faced and mournful',
        '17D': 'Fuss over the tiniest faults',
        '19D': '"Here we ___"',
        '21D': '"By ___" (alone)',
        '22D': 'The lesson at the end of a fable',
        '23D': 'Boiling mad',
        '24D': 'Called by a certain handle',
        '26D': 'Those voting no',
        '27D': 'One part of a play\'s act',
        '28D': 'Grassy plant found along marshy banks',
        '30D': 'Ship off in the mail',
        '33D': 'A fib; or stretch out',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0019 — "Up and Away" (18 blocks)
const FULL_0019 = buildPuzzle({
    id: 'full-0019',
    size: 'full',
    difficulty: 'medium',
    layout: ['PLUCK#ABASH', 'AISLE#DELTA', 'SKEIN#DAMES', 'TERM#RETORT', '###BEEN#SEE', 'TAP#AND#TON', 'AVE#GEAR###', 'MILDEW#EASE', 'EATER#CANON', 'STEAL#OCTAD', 'TEDDY#WHIPS'],
    title: 'Up and Away',
    clues: {
        '1A': 'Spirited courage',
        '6A': 'Embarrass into silence',
        '11A': 'Walkway between rows of theater seats',
        '12A': 'Fourth Greek letter, shaped like a triangle',
        '13A': 'A loose coil of yarn',
        '14A': 'Grand ladies, in old song titles',
        '15A': 'A school semester or a set length of time',
        '16A': 'A sharp comeback',
        '17A': 'Where you have ___ all your life',
        '19A': 'Set eyes on',
        '20A': 'Gentle pat or faucet',
        '23A': 'Bread ___ butter',
        '24A': 'Two thousand pounds, in weight',
        '25A': 'Lane, on a street sign (abbr.)',
        '26A': 'Equipment for the job',
        '28A': 'The damp cellar\'s gray fuzz',
        '30A': 'Relax, or put at ___',
        '34A': 'One who dines; a hearty ___',
        '35A': 'An accepted rule or standard of judgment',
        '36A': 'A bargain that feels like robbery',
        '37A': 'A group of eight',
        '38A': 'A child’s cuddly stuffed bear',
        '39A': 'Beats the cream stiff',
        '1D': 'Days gone by',
        '2D': 'Similar to; "she looks ___ her mother"',
        '3D': 'One who uses a tool or a website',
        '4D': 'Go up the ladder',
        '5D': 'One\'s range of knowledge',
        '6D': 'Extra bits added at the end of a book',
        '7D': 'The steady thump of a drum',
        '8D': 'Very nearly, but not quite',
        '9D': 'The hi-fi in the living room',
        '10D': 'Hurry along',
        '16D': 'Sign up again; make fresh once more',
        '18D': 'With great enthusiasm',
        '20D': 'Least wild',
        '21D': 'Take to the skies at the controls',
        '22D': 'Showered with, as snowballs',
        '27D': 'Stretch out an arm for',
        '29D': 'Like a doornail, in the saying',
        '31D': 'Against (prefix)',
        '32D': 'A bar at the basin',
        '33D': 'Tail-end portions; loose ___',
        '35D': 'Bessie in the barn',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0020 — "Old School" (18 blocks)
const FULL_0020 = buildPuzzle({
    id: 'full-0020',
    size: 'full',
    difficulty: 'medium',
    layout: ['#SPAR#SPEAR', 'SCARE#CRUDE', 'HOSTS#HORDE', 'OUT#TWOFOLD', 'WRAP#HOUSES', '###RAILS###', 'SCROLL#EAST', 'PROBLEM#FOR', 'AUDIO#AIOLI', 'TEENY#SCOOP', 'SLOGS#SETS#'],
    title: 'Old School',
    clues: {
        '1A': 'Trade light blows, as boxers warming up',
        '5A': 'Long weapon of ancient armies; an asparagus stalk',
        '10A': 'Give a fright',
        '11A': 'Raw and unrefined, like a barrel of oil',
        '12A': 'People who welcome guests into their home',
        '13A': 'Roaming crowd that swarms in',
        '14A': 'Not at home',
        '15A': 'Double',
        '17A': 'Bundle up against the cold',
        '19A': 'Homes along the block',
        '20A': 'Bars or fences that keep you from falling',
        '22A': 'Rolled-up sheet of parchment',
        '25A': 'Toward the sunrise',
        '29A': 'A puzzle needing a solution',
        '31A': 'In place of, in a swap',
        '32A': 'The sound half of a broadcast',
        '33A': 'Garlic mayonnaise spread',
        '35A': 'Very tiny indeed',
        '36A': 'One serving of ice cream; a news beat',
        '37A': 'Trudges through the mud',
        '38A': 'Places where you sit, as in a theater',
        '1D': 'Scrub till it shines',
        '2D': 'Italian noodles, the foundation of many dinners',
        '3D': 'What hangs in a gallery',
        '4D': 'Take a load off',
        '5D': 'Where lessons are taught; a group of fish',
        '6D': 'Overflowing, as apologies',
        '7D': 'Continental coins replacing the franc and lira',
        '8D': 'Muddle or confuse',
        '9D': 'Marsh grasses; clarinet parts',
        '10D': 'Put on display',
        '16D': 'For a ___ (for a stretch of time)',
        '18D': 'Asking the hard questions',
        '21D': 'Brass and bronze, for two',
        '22D': 'Old-time shoe covers; little quarrels',
        '23D': 'Deliberately unkind or harsh',
        '24D': 'Cowboy show with bucking broncos',
        '26D': '"The game is ___!"',
        '27D': 'Performances for one',
        '28D': 'A journey; stumble',
        '30D': 'A great heap or pile of stuff',
        '34D': 'It chills your drink',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0021 — "Sweet Tooth" (18 blocks)
const FULL_0021 = buildPuzzle({
    id: 'full-0021',
    size: 'full',
    difficulty: 'hard',
    layout: ['CACHE#MACHO', 'ALLOY#INLET', 'STORE#STILT', 'HOUR#STIFLE', '#STIGMA#FOR', '###DRAKE###', 'ROW#ELECTS#', 'ANIMAL#LAKE', 'ISLET#CABIN', 'DECAL#OILED', 'STONY#PRESS'],
    title: 'Sweet Tooth',
    clues: {
        '1A': 'A hidden stash',
        '6A': 'Tough-guy in manner',
        '11A': 'A blend of metals, like brass',
        '12A': 'Narrow bay where the sea reaches the land',
        '13A': 'Shop, or to stock away',
        '14A': 'One of a circus walker\'s tall poles',
        '15A': 'Sixty minutes',
        '16A': 'Hold back, as a yawn',
        '17A': 'An unfair mark of shame',
        '19A': '"This gift is ___ you"',
        '20A': 'A male duck',
        '22A': 'Move a boat with oars',
        '25A': 'Chooses by ballot',
        '28A': 'Any creature of the kingdom',
        '30A': 'Placid or Erie',
        '32A': 'A very small island',
        '33A': 'A log house in the woods',
        '34A': 'A stick-on design',
        '35A': 'Kept from squeaking',
        '36A': 'Hard-hearted; full of pebbles',
        '37A': 'Push down on; also the newspapers',
        '1D': 'Bills and coins',
        '2D': 'Lower female singing voices',
        '3D': 'Pull and influence',
        '4D': 'Frightful and dreadful',
        '5D': 'You look with it',
        '6D': 'A slip-up',
        '7D': 'Against (prefix)',
        '8D': 'A sheer rock face',
        '9D': 'A friendly greeting',
        '10D': 'Furry animal that floats on its back and cracks shells',
        '16D': 'Not big',
        '18D': 'Very much so',
        '21D': 'Cream-filled pastry with chocolate on top',
        '22D': 'Sudden surprise attacks',
        '23D': 'The start of something; "___ of war"',
        '24D': '"Will comply," over the radio',
        '26D': 'Where the family gathers for supper',
        '27D': 'What forecasts call partly cloudy',
        '29D': 'Unkind or cruel',
        '31D': 'Finishes; brings to a close',
        '33D': 'Officer, informally',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0022 — "Taking Flight" (18 blocks)
const FULL_0022 = buildPuzzle({
    id: 'full-0022',
    size: 'full',
    difficulty: 'hard',
    layout: ['STUDS#HARPS', 'TULIP#AIOLI', 'UTTER#URBAN', 'FOR#YELLING', 'FRAMED#INK#', '###ORGAN###', '#PAN#ENERGY', 'FITTEST#ERA', 'INLAY#LONER', 'STAGE#ENDED', 'HOSES#RESTS'],
    title: 'Taking Flight',
    clues: {
        '1A': 'Snaps on a western shirt; wall timbers',
        '6A': 'Angels\' instruments, in pictures',
        '11A': 'Cup-shaped spring flower from a bulb',
        '12A': 'Garlic mayonnaise spread',
        '13A': 'Speak aloud; pronounce a word',
        '14A': 'Of the big city',
        '15A': '"A letter ___ you arrived today"',
        '16A': 'Using one\'s outdoor voice',
        '18A': 'Put behind glass on the wall',
        '20A': 'What fills a fountain pen',
        '21A': 'Pipe instrument heard in church',
        '23A': 'It sizzles on the stove',
        '25A': 'Pep and vigor',
        '29A': '"Survival of the ___"',
        '31A': 'A long age or span of time',
        '32A': 'Decorative wood set into wood',
        '33A': 'One who keeps to himself',
        '35A': 'Where the play unfolds',
        '36A': 'Brought to a close',
        '37A': 'Rubber tubes for watering the garden',
        '38A': 'Takes a break; relaxes',
        '1D': 'Odds and ends',
        '2D': 'A pupil’s private teacher',
        '3D': 'Extreme; far beyond the ordinary',
        '4D': 'One of a pair of dice',
        '5D': 'More nimble for one\'s age',
        '6D': 'A heavy load to carry',
        '7D': 'Company with a fleet of planes',
        '8D': 'Red-breasted songbird of spring',
        '9D': 'One board of the walkway',
        '10D': 'Carry a tune',
        '17D': 'The outer borders or rims',
        '19D': 'A picture made of many pictures',
        '22D': 'A buck\'s branching crown',
        '23D': 'A spotted pony; a speckled bean',
        '24D': 'A book of maps',
        '26D': 'Rips or tears apart violently',
        '27D': 'Say hello to',
        '28D': 'Three feet at a time',
        '29D': 'What the angler is after',
        '30D': 'What spectacles help',
        '34D': 'The number after zero',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0023 — "Fine Fabric" (18 blocks)
const FULL_0023 = buildPuzzle({
    id: 'full-0023',
    size: 'full',
    difficulty: 'easy',
    layout: ['HUMAN#SWAMI', 'ANISE#ARGON', 'LICKS#LEAVE', 'FOR#TREATER', '#NOBLE#TEST', '###REACH###', 'HERO#CLEAR#', 'EXECUTE#BUT', 'ATLAS#ADORE', 'PRIDE#NAVAL', 'SATED#SMELL'],
    title: 'Fine Fabric',
    clues: {
        '1A': 'A person; one of mankind',
        '6A': 'Wise spiritual teacher from the East',
        '11A': 'Licorice-flavored seed used in baking',
        '12A': 'Gas that fills glowing colored signs',
        '13A': 'Quick tongue strokes, as an ice cream cone gets',
        '14A': 'Go away, or take time off from work',
        '15A': '"This bouquet is ___ you, dear"',
        '16A': 'The one picking up the check',
        '18A': 'Grand and dignified, like a lord',
        '20A': 'An exam, or a trial run',
        '21A': 'Stretch out an arm for',
        '23A': 'Brave figure who saves the day',
        '26A': 'Free of clouds',
        '29A': 'Carry out, as a plan',
        '31A': '"Last ___ not least"',
        '33A': 'The book of maps again',
        '34A': 'Love and admire deeply',
        '36A': 'What goeth before a fall; a lion family',
        '37A': 'Of the fleet',
        '38A': 'Full to contentment',
        '39A': 'What the nose knows',
        '1D': 'Fifty cents of a dollar',
        '2D': 'Workers\' organized labor group',
        '3D': 'Very tiny, with a prefix',
        '4D': 'Request, or pose a question',
        '5D': 'Snuggle in close',
        '6D': 'A store\'s big bargain event',
        '7D': 'Encircle, as holly around a door',
        '8D': 'Hard stone, like striped quartz',
        '9D': 'Changes address',
        '10D': 'Completely still and unmoving',
        '17D': 'Respond',
        '19D': 'Rich cloth woven with raised designs',
        '22D': 'Tidies up',
        '23D': 'Large piles, as of laundry or leaves',
        '24D': 'Additional; more than the usual amount',
        '25D': 'Touched a match to again',
        '27D': 'Overhead',
        '28D': 'Of the countryside',
        '30D': 'Not brand new; already broken in',
        '32D': 'Let someone know the news',
        '35D': 'It holds a river back',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0024 — "Garden Border" (18 blocks)
const FULL_0024 = buildPuzzle({
    id: 'full-0024',
    size: 'full',
    difficulty: 'medium',
    layout: ['KARMA#GUSTO', 'IDEAL#OPTED', 'DIARY#THIRD', 'DECKS##ELSE', 'OUT#SMALLER', '###GUARD###', 'ATTEMPT#ARM', 'LIAR##INDIE', 'GAMMA#COOPS', 'AREAS#LOPES', 'EARNS#ENTRY'],
    title: 'Garden Border',
    clues: {
        '1A': 'The idea that good deeds come back to you',
        '6A': 'Hearty relish',
        '11A': 'Just perfect; couldn\'t be better',
        '12A': 'Chose to do something',
        '13A': 'A daily journal of one’s doings',
        '14A': 'Base before home',
        '15A': 'Ships\' floors; packs of cards',
        '16A': 'Otherwise; if not',
        '17A': '"Time ___," called by an umpire',
        '18A': 'Less roomy',
        '21A': 'One posted at the gate',
        '22A': 'A try',
        '25A': 'It bends at the elbow',
        '28A': 'One who does not tell the truth',
        '29A': 'Independent, as a small film studio',
        '31A': 'The third Greek letter',
        '33A': 'Henhouses',
        '34A': 'Open spaces or fields of study',
        '35A': 'Runs with an easy stride',
        '36A': 'Brings home',
        '37A': 'Doorway into a building; a written record',
        '1D': 'Affectionate word for a youngster',
        '2D': 'A fond farewell, French-style',
        '3D': 'Respond',
        '4D': 'A spot or a stain; a grade',
        '5D': 'Low garden flower in sweet white clusters',
        '6D': 'Came into possession of; "I ___ a letter"',
        '7D': 'Backed on appeal',
        '8D': 'Quiet and motionless',
        '9D': 'Short and to the point',
        '10D': 'Stranger, or more peculiar',
        '19D': 'A guide to find the way',
        '20D': 'A piece in the paper; "a" or "the"',
        '21D': 'Language spoken in Berlin',
        '22D': 'Slimy green growth on a pond',
        '23D': 'Sparkling crown for a queen',
        '24D': 'One who trains wild animals',
        '25D': 'Take in as one\'s own',
        '26D': 'Closer to ready, as fruit',
        '27D': 'Needing a good tidying',
        '30D': 'When the whistle blew for lunch',
        '32D': 'Donkey, plainly',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0025 — "County Fair" (18 blocks)
const FULL_0025 = buildPuzzle({
    id: 'full-0025',
    size: 'full',
    difficulty: 'hard',
    layout: ['CHIRP#ACING', 'ROVER#ROMAN', 'ANODE#GUAVA', 'FOR#YOUNGER', 'TRY##RETELL', '###MUDDY###', 'ARCANE##SEC', 'TOURERS#CAR', 'LARVA#USAGE', 'ACRES#CALLS', 'SHYLY#HYPES'],
    title: 'County Fair',
    clues: {
        '1A': 'A little bird\'s cheerful note',
        '6A': 'Getting a perfect score on',
        '11A': 'One who wanders far and wide',
        '12A': 'Of ancient Italy\'s great empire',
        '13A': 'Terminal of a battery, marked plus or minus',
        '14A': 'Sweet pink tropical fruit',
        '15A': '"Three cheers ___ the winner!"',
        '16A': 'Junior of the two',
        '18A': 'Give it a ___ (make an attempt)',
        '19A': 'Share the story once more',
        '20A': 'Like boots after a wet garden',
        '22A': 'Known only to a few',
        '25A': 'Just a moment, briefly',
        '28A': 'Drivers out to see the sights',
        '30A': 'It rolls down the road',
        '31A': 'A young grub before it becomes a beetle or moth',
        '32A': 'The way something is used',
        '34A': 'Fields are measured in them',
        '35A': 'Rings up on the telephone',
        '36A': 'With a bashful look',
        '37A': 'Talks up too much',
        '1D': 'Skill at making things by hand',
        '2D': 'Great respect and esteem',
        '3D': 'Creamy-white material from elephant tusks',
        '4D': 'A stop sign’s color',
        '5D': 'What the hawk hunts',
        '6D': 'Made the case',
        '7D': 'What a courthouse town is seat of',
        '8D': 'What the mirror shows',
        '9D': 'An orange with a bellybutton',
        '10D': 'A twisted knot in old wood',
        '17D': 'Command, as from a captain',
        '20D': 'A wonder to behold',
        '21D': 'Not quite comfortable',
        '22D': 'Book of maps for travelers',
        '23D': 'The unwelcome kitchen scurrier',
        '24D': 'Spiced dish of India; groom a horse',
        '25D': 'Where the barber works',
        '26D': 'Majestic bird and symbol of America',
        '27D': 'Peppery little salad green',
        '29D': '"___ is life"',
        '33D': 'Speak your piece',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0026 — "Walking the Dog" (18 blocks)
const FULL_0026 = buildPuzzle({
    id: 'full-0026',
    size: 'full',
    difficulty: 'medium',
    layout: ['SCOPE#SPLIT', 'TAPIR#ALONE', 'ARENA#FAUNS', 'FOR##BASSET', 'FLAT#ARTERY', '###RADII###', 'APPALL#CATS', 'PURITY##BUT', 'SPINE#ADOBO', 'EIDER#LIVER', 'SLEDS#LEERY'],
    title: 'Walking the Dog',
    clues: {
        '1A': 'The reach of a telescope',
        '6A': 'Divide down the middle; a banana dessert',
        '11A': 'Hoofed animal with a long snout, related to horses',
        '12A': 'With no company',
        '13A': 'The ring where the big match is held',
        '14A': 'Goat-legged fellows of myth',
        '15A': '"This song is just ___ you"',
        '16A': 'Droopy-eared hound',
        '17A': 'Level and even, like a tabletop',
        '19A': 'A major blood vessel; a main road',
        '20A': 'Two of a kind, in geometry circles, on a die',
        '22A': 'Shock and dismay',
        '25A': 'Tabbies and toms',
        '29A': 'Freedom from any mixture',
        '30A': 'On the other hand; however',
        '31A': 'A book\'s backbone',
        '32A': 'Filipino stew in a tangy marinade',
        '34A': 'Sea duck prized for its soft down feathers',
        '35A': 'Onions\' dinner partner, on some menus',
        '36A': 'Winter hill riders',
        '37A': 'Wary and doubtful',
        '1D': 'The team and crew of an office',
        '2D': 'A merry Christmas song',
        '3D': 'A grand musical drama with singing',
        '4D': 'What the bowler aims to topple',
        '5D': 'A long period of history',
        '6D': 'Expedition among lions and elephants',
        '7D': 'What many a toy is made of',
        '8D': 'A no-good so-and-so',
        '9D': 'Closer to the center; deep within',
        '10D': 'Short-tempered',
        '16D': 'In sore need — "wanted ___"',
        '18D': 'Schooled in the work',
        '21D': 'Makes changes to',
        '22D': 'Curved ends of cathedrals',
        '23D': 'A student; part of the eye',
        '24D': 'What goeth before a fall; a lion family',
        '26D': 'Overhead',
        '27D': 'A potato, botanically speaking',
        '28D': 'What every quilt and scar can tell',
        '32D': 'Every bit of it',
        '33D': 'One of a pair of dice',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0027 — "Small Matter" (18 blocks)
const FULL_0027 = buildPuzzle({
    id: 'full-0027',
    size: 'full',
    difficulty: 'easy',
    layout: ['SCARE#LAPSE', 'TODAY#AGAIN', 'ALONE#TONED', 'FOR#SET#EVE', 'FREE#VEILED', '###AVERT###', 'MATTER#SLIP', 'ASH#EYE#ONE', 'SPEAR#VOCAL', 'TITLE#ERUPT', 'SCALD#NESTS'],
    title: 'Small Matter',
    clues: {
        '1A': 'Give a fright',
        '6A': 'A slip of memory',
        '11A': 'This very day',
        '12A': 'One more time',
        '13A': 'With no company',
        '14A': 'Firm and well-exercised, as muscles',
        '15A': 'On behalf of; in support of',
        '16A': '"Ready, ___, go!"',
        '18A': 'The day before a holiday',
        '19A': 'At no cost',
        '21A': 'Thinly hidden, as a hint',
        '23A': 'Sidestep, as a question',
        '25A': '"What\'s the ___?"',
        '28A': 'A little skid; a pink dismissal',
        '32A': 'What\'s left in the fireplace',
        '33A': 'You wink with it',
        '35A': 'The loneliest number',
        '36A': 'Long weapon of ancient armies; an asparagus stalk',
        '38A': 'Sung, not played; outspoken',
        '40A': 'A book\'s name',
        '41A': 'Burst forth, as a volcano',
        '42A': 'Burn the skin with boiling water',
        '43A': 'Cozy homes birds build in trees',
        '1D': 'The workers, collectively',
        '2D': 'What crayons add',
        '3D': 'Love and cherish deeply',
        '4D': 'Went on foot, quickly',
        '5D': 'What you see with',
        '6D': 'The second of the two',
        '7D': 'In the past; "long ___"',
        '8D': 'A jury, or a section of a quilt',
        '9D': 'It strains the lumps out',
        '10D': 'Brought to a close',
        '17D': 'Each and all of them',
        '20D': 'Have a meal',
        '22D': 'Belonging to it',
        '24D': 'Swung suddenly aside',
        '25D': 'A schooner\'s tall poles',
        '26D': 'Savoury jelly that sets around cold meat',
        '27D': 'Greek letter that looks like a circle with a line',
        '29D': 'The exact spot, in formal language',
        '30D': 'Out of place; not fitting',
        '31D': 'Trappers\' furs',
        '34D': 'Smooth and flat; also a number divisible by two',
        '37D': 'Every last one',
        '39D': 'Rock worth mining',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0028 — "River’s End" (18 blocks)
const FULL_0028 = buildPuzzle({
    id: 'full-0028',
    size: 'full',
    difficulty: 'easy',
    layout: ['LARGE#WARES', 'EVILS#AGENT', 'DEPOT#SEDGE', '###BUT#SURE', 'APPEARS#CAR', 'PRO#RAT#EVE', 'PET#YIELDED', 'ECHO#LEE###', 'NOONS#PAPAS', 'DOLCE#EVADE', 'SKEET#DENSE'],
    title: 'River’s End',
    clues: {
        '1A': 'Roomy, as a shirt size',
        '6A': 'What the peddler spreads out',
        '11A': '"The lesser of two ___"',
        '12A': 'A representative who acts on your behalf',
        '13A': 'The old train station',
        '14A': 'Grassy plant found along marshy banks',
        '15A': 'However, on the other hand',
        '17A': 'Confident and certain',
        '18A': 'Comes into view',
        '22A': 'It rolls down the road',
        '23A': 'An expert; the "for" side',
        '24A': 'Rodent that scurries through the cellar',
        '25A': 'The night before a holiday',
        '26A': 'A dog or cat at home',
        '27A': 'Gave way',
        '29A': 'A faint cry that bounces back',
        '31A': 'The sheltered side, out of the wind',
        '32A': 'Twelve o\'clocks',
        '34A': 'Dads, fondly',
        '38A': 'Sweetly, on a music score',
        '39A': 'Dodge; slip away from',
        '40A': 'Clay-pigeon shooting sport',
        '41A': 'Thick and packed tightly together',
        '1D': 'Guided the way, in the past tense',
        '2D': 'Lane, on a street sign (abbr.)',
        '3D': 'A small tear in your trousers',
        '4D': 'The world on a stand',
        '5D': 'Where the river meets the tide',
        '6D': 'Used to be',
        '7D': 'Grows older; long spans of time',
        '8D': 'Marked down',
        '9D': 'Cut letters into metal',
        '10D': 'Held the wheel',
        '16D': 'A winding mountain path',
        '18D': 'Tacks on at the end',
        '19D': 'Get partly done on the stove ahead of time',
        '20D': 'The street crater that jolts the car',
        '21D': 'Soaked, as tea leaves',
        '28D': 'Go away; depart',
        '30D': 'A single time; just one occasion',
        '33D': 'Put the table for dinner',
        '35D': 'It sizzles on the stove',
        '36D': 'Notices in the newspaper selling things, for short',
        '37D': 'Notice with your eyes',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0029 — "Grand Manor" (18 blocks)
const FULL_0029 = buildPuzzle({
    id: 'full-0029',
    size: 'full',
    difficulty: 'easy',
    layout: ['HILLS#SMASH', 'ADIEU#CACTI', 'LEAVE#HIRED', 'FARE#MILORD', '###LIES#SEE', 'MET#DAM#SON', 'ORE#ELSE###', 'DRAMAS#ALSO', 'EASEL#BRAWN', 'STEEL#ATTIC', 'TASTY#THEME'],
    title: 'Grand Manor',
    clues: {
        '1A': 'What San Francisco is famous for',
        '6A': 'Break to pieces with a great crash',
        '11A': 'French farewell',
        '12A': 'Prickly desert plants',
        '13A': 'Go away, or take time off from work',
        '14A': 'Brought on for a wage',
        '15A': 'The bus ride\'s price',
        '16A': 'How the butler addresses the master',
        '17A': 'Fibs and stories',
        '19A': 'Take in with your eyes',
        '20A': 'Came together, in past tense',
        '23A': 'It holds a river back',
        '24A': 'A man\'s male child',
        '25A': 'Rock worth mining',
        '26A': 'If not; otherwise',
        '28A': 'Serious plays',
        '30A': 'In addition; as well',
        '34A': 'What holds the painter\'s canvas',
        '35A': 'Muscle power',
        '36A': 'The strong metal in girders and knives',
        '37A': 'Storage space up under the roof',
        '38A': 'Pleasing to the tongue',
        '39A': 'The main idea running through a story',
        '1D': 'One of two equal parts',
        '2D': 'A bright thought or plan',
        '3D': 'One who does not tell the truth',
        '4D': 'Flat and even, like a still floor',
        '5D': 'Take to court',
        '6D': 'Deep splits in the ranks',
        '7D': 'Letters carried by the postman',
        '8D': 'From one side to the other',
        '9D': 'The hi-fi in the living room',
        '10D': 'Out of sight',
        '16D': 'Breakfast, lunch, and dinner',
        '18D': 'In a perfect world',
        '20D': 'Not one to brag',
        '21D': 'A book’s listed corrections',
        '22D': 'Kids around with',
        '27D': 'The planet we all live on',
        '29D': 'Come together face to face',
        '31D': 'Not early',
        '32D': 'Do the backstroke',
        '33D': 'A single time, no more',
        '35D': 'Louisville Slugger, for one',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0030 — "Yes Sirree" (18 blocks)
const FULL_0030 = buildPuzzle({
    id: 'full-0030',
    size: 'full',
    difficulty: 'medium',
    layout: ['SMEAR#YELPS', 'TINGE#EXALT', 'ACTED#SPRAY', 'FRESH##EVIL', 'FOR#EDUCATE', '###SAINT###', 'BESIDES#BUT', 'EVER##THINE', 'RETRO#RIOTS', 'TRUED#ADMIT', 'HYPED#PEELS'],
    title: 'Yes Sirree',
    clues: {
        '1A': 'Spread thickly, as butter',
        '6A': 'Sharp little cries',
        '11A': 'A faint trace of color',
        '12A': 'Praise highly',
        '13A': 'Took the part',
        '14A': 'A fine mist; a bouquet of blossoms',
        '15A': 'Just picked',
        '16A': 'Wicked; the opposite of good',
        '17A': 'On behalf of, or in favor of',
        '18A': 'Teach and bring up',
        '21A': 'A halo wearer',
        '22A': 'In addition to',
        '25A': 'Word that joins two contrasting ideas',
        '28A': 'At any time',
        '29A': 'Old-fashioned word for "yours"',
        '31A': 'In a style from years gone by',
        '33A': 'Unruly, noisy public disturbances',
        '34A': 'Brought exactly square',
        '35A': 'Own up to; let in',
        '36A': 'Built up with great excitement',
        '37A': 'Strips the potatoes',
        '1D': 'The team and crew of an office',
        '2D': 'Very small, with a prefix',
        '3D': 'Type onto the screen, or step inside',
        '4D': 'Grows older; long spans of time',
        '5D': 'One with carrot-colored locks',
        '6D': 'The opposite of no',
        '7D': 'Count on',
        '8D': 'A young insect, like a caterpillar',
        '9D': 'A braid of hair',
        '10D': 'A flair all one\'s own',
        '19D': 'One of a pair of dice',
        '20D': 'Loosen from the buckles',
        '21D': '"No, ___!" (emphatic refusal)',
        '22D': 'A bunk on a train or ship',
        '23D': 'Each and all, without exception',
        '24D': 'Get something ready to use',
        '25D': 'A natural community of plants and animals',
        '26D': 'Up to the time that',
        '27D': 'School exams',
        '30D': 'Play the first half of seek',
        '32D': 'Peculiar; not even',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0031 — "Around Town" (18 blocks)
const FULL_0031 = buildPuzzle({
    id: 'full-0031',
    size: 'full',
    difficulty: 'medium',
    layout: ['#CLIP#SCRUB', 'TRADE#ELOPE', 'HATED#CAUSE', 'OBTAIN#USER', 'USE#COSSETS', '###TABLE###', 'MOVABLE#TAN', 'UPON#ENGAGE', 'STINT#DIMES', 'TILER#EVENT', 'SCARY#REST#'],
    title: 'Around Town',
    clues: {
        '1A': 'Snip with scissors, as a coupon',
        '5A': 'Give a good hard washing',
        '10A': 'Buying and selling between businesses',
        '11A': 'Skip the big wedding',
        '12A': 'Strongly disliked',
        '13A': 'The reason behind something',
        '14A': 'Come by; get',
        '16A': 'One who operates a machine or product',
        '17A': 'Put a tool to work',
        '18A': 'Pampers and coddles',
        '20A': 'Where the family gathers for supper',
        '21A': 'Like feast days that shift each year',
        '24A': 'What a beach day may give you',
        '27A': '"Once ___ a time…"',
        '28A': 'Take on; promise to marry',
        '30A': 'A set period of time; a limit',
        '32A': 'Ten-cent pieces',
        '33A': 'One who lays the bathroom floor',
        '34A': 'A wedding or a fair, say',
        '35A': 'Spooky, like a ghost story',
        '36A': 'Take a break and put your feet up',
        '1D': 'Sideways walkers of the shore',
        '2D': 'Coffee with steamed milk, Italian style',
        '3D': 'Bright thought',
        '4D': 'A taxi you pedal',
        '5D': 'Just a moment, briefly',
        '6D': 'One part of a contract',
        '7D': 'Stir from sleep',
        '8D': 'Topple the favorite; troubled',
        '9D': 'Cold ones at the tavern',
        '10D': 'The old word for "you"',
        '15D': 'Grand and dignified',
        '19D': 'Willow-thin',
        '20D': 'One who cures hides',
        '21D': 'Things one simply can\'t skip',
        '22D': 'Having to do with the eye',
        '23D': '"And there you have it!"',
        '24D': 'Gentles a wild horse',
        '25D': 'A secret operative, or a salesperson',
        '26D': 'Cosy spot for a bird',
        '29D': 'Hand over',
        '31D': 'Give it a go',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0032 — "Sunday Sketch" (18 blocks)
const FULL_0032 = buildPuzzle({
    id: 'full-0032',
    size: 'full',
    difficulty: 'medium',
    layout: ['STEPS#MACHO', 'PIXIE#INLET', 'ARISE#STILT', 'REST#STIFLE', '#STIGMA#FOR', '###LOOKS###', 'HIS#SKETCH#', 'ESCAPE#ROOM', 'ALONE#GAMMA', 'REPEL#AIMED', 'STEWS#SNARE'],
    title: 'Sunday Sketch',
    clues: {
        '1A': 'Stairs taken one at a time',
        '6A': 'Tough-guy in manner',
        '11A': 'A mischievous little sprite',
        '12A': 'A small bay or arm of water',
        '13A': 'Get up onto your feet; stand and ___',
        '14A': 'One of a circus walker\'s tall poles',
        '15A': 'A nice sit-down after a long day',
        '16A': 'Hold back, as a yawn',
        '17A': 'An unfair mark of shame',
        '19A': 'In place of, as a substitute',
        '20A': 'Takes a gander',
        '22A': 'Belonging to that fellow',
        '25A': 'A quick pencil drawing',
        '28A': 'Slip away',
        '30A': 'Board\'s partner',
        '32A': 'With no company',
        '33A': 'The third Greek letter',
        '34A': 'Drive back',
        '35A': 'Pointed toward the target',
        '36A': 'Simmers slowly; frets',
        '37A': 'Trap for catching small animals',
        '1D': 'Trade light blows, as boxers warming up',
        '2D': 'They get bald and need changing',
        '3D': 'Be real; have being',
        '4D': 'The flower part that receives the pollen',
        '5D': 'Take a look; "come and ___"',
        '6D': 'A slip-up',
        '7D': 'Against (prefix)',
        '8D': 'A sheer rock face',
        '9D': 'A friendly greeting',
        '10D': 'Furry animal that floats on its back and cracks shells',
        '16D': 'It curls up from the chimney',
        '18D': 'Matthew through John',
        '21D': 'Pour through a sieve; a pulled muscle',
        '22D': 'Listens to',
        '23D': 'A very small island',
        '24D': 'The range of what something covers or includes',
        '26D': 'The pause in a sentence',
        '27D': 'Greek poet credited with the Odyssey, or a four-base hit',
        '29D': 'Once more; ___ and again',
        '31D': 'Built, or had for breakfast',
        '33D': 'What you pump into a tire, for short',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0033 — "Helping Hands" (18 blocks)
const FULL_0033 = buildPuzzle({
    id: 'full-0033',
    size: 'full',
    difficulty: 'easy',
    layout: ['LIPPY#BRAKE', 'ADORE#RISEN', 'SLOOP#ASSET', 'HERO#BIKINI', '###FEEL#SET', 'TAP#ALL#TRY', 'AVE#GOES###', 'MILDEW#TELL', 'EATER#FOLIO', 'STEAL#ONSET', 'TEDDY#REEDS'],
    title: 'Helping Hands',
    clues: {
        '1A': 'Quick with backtalk',
        '6A': 'The stopping pedal',
        '11A': 'Love and admire greatly',
        '12A': 'Up with the sun',
        '13A': 'A single-masted sailboat',
        '14A': 'A handy thing of value',
        '15A': 'Brave figure who saves the day',
        '16A': 'Daring two-piece swimsuit',
        '17A': 'Get a sense of',
        '19A': 'Place the table for supper',
        '20A': 'Gentle pat or faucet',
        '23A': 'Every bit of it',
        '24A': 'Give it a go; make an attempt',
        '25A': 'Lane, on a street sign (abbr.)',
        '26A': 'Departs',
        '28A': 'The damp cellar\'s gray fuzz',
        '30A': 'Let someone know the news',
        '34A': 'One who dines',
        '35A': 'A large-format old book',
        '36A': 'A bargain that feels like robbery',
        '37A': 'The start of something; "___ of war"',
        '38A': 'A child’s cuddly stuffed bear',
        '39A': 'Marsh grasses; clarinet parts',
        '1D': 'Strike of a whip, or part of the eye\'s fringe',
        '2D': 'Doing nothing; at rest',
        '3D': 'Church-mouse humble',
        '4D': 'What the pudding provides, in the saying',
        '5D': 'Casual yes',
        '6D': 'Reading done with the fingertips',
        '7D': 'A chance of danger or loss',
        '8D': 'Lend a hand',
        '9D': 'Sharper of eye',
        '10D': 'A thing that exists',
        '16D': 'Down under, as decks',
        '18D': 'With great enthusiasm',
        '20D': 'Least wild',
        '21D': 'Take to the skies at the controls',
        '22D': 'Showered with, as snowballs',
        '27D': 'A pebble or a precious gem',
        '29D': 'Like a doornail, in the saying',
        '31D': 'In addition; other than that',
        '32D': 'Told a whopper',
        '33D': 'Plenty and then some',
        '35D': 'On behalf of someone',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0034 — "Winter Sun" (18 blocks)
const FULL_0034 = buildPuzzle({
    id: 'full-0034',
    size: 'full',
    difficulty: 'easy',
    layout: ['OUT#MOM#TIN', 'USE#ANYTIME', 'SUM#RESHAPE', 'TAPAS#TIRED', 'SLOW#FINALS', '###KNOCK###', 'DRAWER#ELSE', 'REGAL#BRAIN', 'OVERSEE#BED', 'SUNDOGS#EVE', 'SET#NOT#LED'],
    title: 'Winter Sun',
    clues: {
        '1A': 'Word an umpire shouts at the plate',
        '4A': 'Dad\'s better half, say the kids',
        '7A': 'Metal of many a soup can',
        '10A': 'Put to good purpose; make ___ of',
        '11A': '"You\'re welcome — ___!"',
        '13A': 'The total',
        '14A': 'Mold into a new form',
        '15A': 'Little Spanish plates',
        '17A': 'Worn out and sleepy',
        '18A': 'Not quick; taking your time',
        '19A': 'Exams at semester\'s end',
        '20A': 'A rap at the door',
        '22A': 'Where the socks are kept',
        '25A': 'Or ___ (if not)',
        '29A': 'Fit for a throne',
        '30A': 'The thinking organ inside your head',
        '31A': 'Keep an eye on the whole operation',
        '33A': 'Where you lay your head at night',
        '34A': 'Bright spots flanking a winter sun',
        '35A': 'The day before a holiday',
        '36A': 'Put down in place, as a table for dinner',
        '37A': '\'Whether or ___\'',
        '38A': 'Guided by the hand; past tense of lead',
        '1D': 'Throws out of office',
        '2D': 'Ordinary; what normally happens',
        '3D': 'The steady pace a conductor keeps',
        '4D': 'The red planet',
        '5D': 'The number after zero',
        '6D': 'One drawn to the deep mysteries',
        '7D': 'Sparkling crown for a queen',
        '8D': 'Push into action',
        '9D': 'Must-haves',
        '12D': 'Rodin sculpted a famous one',
        '16D': 'Clumsy and ill at ease',
        '19D': 'In support of',
        '21D': 'A full or half wrestling hold',
        '22D': 'The worthless leavings',
        '23D': 'A stage show of songs and skits',
        '24D': 'Spy working secretly',
        '26D': 'What tells the size and the price',
        '27D': 'It strains the lumps out',
        '28D': 'Brought to a close',
        '30D': 'Sunday clothes, so called',
        '32D': 'One\'s sense of self-importance',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0035 — "Sweet Potato" (18 blocks)
const FULL_0035 = buildPuzzle({
    id: 'full-0035',
    size: 'full',
    difficulty: 'easy',
    layout: ['FOR#DID#FEE', 'OCARINA#ILL', 'RETURNS#RID', 'TAINT#HASTE', 'SNOW#CENTER', '###APART###', 'PLAYER#ATOM', 'SENSE#SCOPE', 'HAT#RECITES', 'ASS#EVADERS', 'WHY#DEN#DAY'],
    title: 'Sweet Potato',
    clues: {
        '1A': 'In favor of something',
        '4A': 'Past tense of "do"',
        '7A': 'A small charge, as for a service',
        '10A': 'Little oval flute, the "sweet potato"',
        '12A': 'Not feeling well',
        '13A': 'What the library expects',
        '14A': 'Took away; got the place clear of',
        '15A': 'A trace of spoilage',
        '16A': 'A great rush and hurry',
        '18A': 'December\'s white blanket',
        '19A': 'The exact middle',
        '20A': 'Separated from one another',
        '22A': 'One taking part in the game',
        '25A': 'The tiniest bit of an element',
        '29A': 'Good judgment; "common ___"',
        '30A': 'The full range or reach of something',
        '31A': 'It tops things off',
        '32A': 'Delivers from memory',
        '34A': 'Stubborn beast of burden',
        '35A': 'Those who duck the question',
        '36A': 'The question a curious child asks most',
        '37A': 'A wild animal\'s cozy hideaway',
        '38A': 'Sunrise to sunset',
        '1D': 'What children build of couch cushions',
        '2D': 'The Atlantic or the Pacific',
        '3D': 'Comparison of two numbers, like three to one',
        '4D': 'What gardeners get under their nails',
        '5D': 'A country lodging',
        '6D': 'One of Santa\'s reindeer',
        '7D': 'Coming before all the others',
        '8D': 'The chosen few at the very top',
        '9D': 'A respected senior member of a community',
        '11D': 'Where planes touch down',
        '17D': 'Relief after a spicy supper',
        '19D': 'It rolls down the road',
        '21D': 'Took a squinting look',
        '22D': '"Oh, nonsense!"',
        '23D': 'The dog-walker\'s line',
        '24D': 'Itching to get going',
        '26D': 'Carried about, in past tense',
        '27D': 'Grand musical drama sung on a big stage',
        '28D': 'Needing a good tidying',
        '30D': 'Read a page quickly; sweep with the eyes',
        '33D': 'The night before a holiday',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0036 — "Opera Night" (18 blocks)
const FULL_0036 = buildPuzzle({
    id: 'full-0036',
    size: 'full',
    difficulty: 'easy',
    layout: ['PHASE#ADDS#', 'RIFTS#SERIF', 'OPTIC#SCENE', 'OPERAS#LACE', 'FOR#POMADED', '###RENEW###', 'PALADIN#BUT', 'AGED#COSINE', 'SAGAS#RIOTS', 'SPARE#ADMIT', '#ELSE#HEELS'],
    title: 'Opera Night',
    clues: {
        '1A': 'A stage or step in a process',
        '6A': 'Sums up, as in arithmetic',
        '10A': 'Splits between old friends',
        '11A': 'The little foot on a printed letter',
        '13A': 'Having to do with the eye',
        '14A': 'One part of a play\'s act',
        '15A': 'Grand nights at the Met',
        '17A': 'The delicate trim on a doily',
        '18A': 'However, on the other hand',
        '19A': 'Slicked down, as barbershop hair',
        '21A': 'Make fresh again, as a magazine subscription',
        '22A': 'A knight of shining virtue',
        '25A': '"Slow ___ steady wins the race"',
        '28A': 'Grown old, like fine wine',
        '29A': 'A trigonometry ratio',
        '31A': 'Long tales of heroes',
        '33A': 'Unruly, noisy public disturbances',
        '34A': 'The fifth wheel, or to set aside',
        '35A': 'Own up to; let in',
        '36A': 'Or ___ (otherwise)',
        '37A': 'Backs of the feet',
        '1D': 'What the pudding provides, in the saying',
        '2D': 'The river horse of Africa',
        '3D': 'Following in time; later than',
        '4D': 'Work the spoon',
        '5D': 'Got away',
        '6D': 'A donkey',
        '7D': 'Blunt a cat\'s scratchers',
        '8D': 'Deep fear of what\'s coming',
        '9D': 'From a time in the past until now',
        '12D': 'Fill the trough',
        '16D': 'Speedy blue video-game hedgehog',
        '20D': 'Candleholder of Hanukkah',
        '21D': 'Storm-tracking screens',
        '22D': 'Hand along the potatoes',
        '23D': 'Selfless, loving kindness, an old Greek term',
        '24D': 'Allowed by the law',
        '25D': 'A natural community of plants and animals',
        '26D': 'Up to the time of; not before',
        '27D': 'Trials and exams',
        '30D': 'Coleslaw or fries, on the menu',
        '32D': 'Take a look at',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0037 — "Family Visit" (18 blocks)
const FULL_0037 = buildPuzzle({
    id: 'full-0037',
    size: 'full',
    difficulty: 'medium',
    layout: ['LUMPS#ANGST', 'INERT#DOLCE', 'OTTER#SWOON', 'NIECES##BUT', 'SERIAL#GETS', '###SMILE###', 'IDLE#CANALS', 'SEE##EYELET', 'SAFER#ERODE', 'ULTRA#RANGE', 'ESSAY#SLEEP'],
    title: 'Family Visit',
    clues: {
        '1A': 'What gravy shouldn\'t have',
        '6A': 'A load of worry',
        '11A': 'Lifeless and dull; without energy',
        '12A': 'Sweetly, on a music score',
        '13A': 'Furry animal that floats on its back and cracks shells',
        '14A': 'Faint from delight',
        '15A': 'A brother\'s daughters',
        '17A': '"Better late ___ never"',
        '18A': 'A story told week by week',
        '19A': 'Comes to have',
        '20A': 'What "cheese" produces',
        '22A': 'Doing nothing; at rest',
        '25A': 'Venice\'s watery streets',
        '29A': 'Take a look with your eyes',
        '30A': 'Little hole for a shoelace',
        '31A': 'Better protected',
        '34A': 'Wears away slowly, as water does rock',
        '35A': 'Extreme; far beyond the ordinary',
        '36A': 'How far a stove burner or a rifle can reach',
        '37A': 'A short written composition',
        '38A': 'What you do each night to rest',
        '1D': 'The big cats with manes, kings of the jungle',
        '2D': 'Loosen, as laces',
        '3D': 'What the cabbie keeps running',
        '4D': 'Down to the last decimal',
        '5D': 'A small brook',
        '6D': 'Newspaper notices selling things',
        '7D': 'This very moment',
        '8D': 'The world on a stand',
        '9D': 'One out looking ahead',
        '10D': 'Canvas shelters used for camping',
        '16D': 'A thin wedge of cake or pie',
        '19D': 'The army\'s top rank; broad, not specific',
        '21D': 'What a good cake has plenty of',
        '22D': 'A matter or topic up for discussion',
        '23D': 'Hands out the cards',
        '24D': 'Turns the driver signals for',
        '26D': 'With no company',
        '27D': 'A narrow shelf, as on a cliff or wall',
        '28D': 'Sharply sloped, like a hillside',
        '32D': 'A long age or span of time',
        '33D': 'A beam of sunshine',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0038 — "Campfire Cooking" (18 blocks)
const FULL_0038 = buildPuzzle({
    id: 'full-0038',
    size: 'full',
    difficulty: 'easy',
    layout: ['STABS#BALER', 'TENET#ALONE', 'ANGER#CLASS', 'FOR#OAK#DUO', 'FRYING#USED', '###OGRES###', 'BEEN#ENERGY', 'RAY#SEC#ARE', 'ARISE#APNEA', 'VENUE#MITER', 'EDGES#PESTS'],
    title: 'Campfire Cooking',
    clues: {
        '1A': 'Wild guesses, informally',
        '6A': 'Machine that bundles the hay',
        '11A': 'A firmly held belief',
        '12A': 'With no company',
        '13A': 'Strong feeling of being cross or upset',
        '14A': 'A room full of pupils',
        '15A': '"This bouquet is ___ you"',
        '16A': 'Mighty tree from a little acorn',
        '18A': 'A twosome',
        '19A': 'What the bacon is doing',
        '21A': 'Second-hand; not fresh from the shop',
        '22A': 'Fairy-tale brutes',
        '24A': '\'Where have you ___?\'',
        '27A': 'Pep and vigor',
        '31A': 'A beam of sunshine',
        '32A': 'Just a moment, briefly',
        '33A': 'They exist; the verb of being',
        '34A': 'Get up from a chair',
        '36A': 'A pause in breathing during sleep',
        '38A': 'Where the event is held',
        '39A': 'A bishop\'s tall hat; a corner joint',
        '40A': 'Outer rims of a table or a coin',
        '41A': 'Backyard nuisances, like aphids and beetles',
        '1D': 'The workers, collectively',
        '2D': 'Deep singing voice between bass and alto',
        '3D': 'Cross and short-tempered',
        '4D': 'Buzzing honey-maker',
        '5D': 'Mighty and muscular',
        '6D': 'Return; the reverse side',
        '7D': 'Every last one',
        '8D': 'Heaps and heaps',
        '9D': 'Follow as a result',
        '10D': 'Lay fresh turf',
        '17D': 'Say yes; be of the same mind',
        '20D': 'A charged particle',
        '21D': 'Put to work for a purpose',
        '23D': 'Pitch the tents',
        '24D': 'Showing courage in the face of danger',
        '25D': 'Having ears, as some owls appear',
        '26D': 'Watching with interest',
        '28D': 'Goes on and on hotly',
        '29D': 'Say hello to',
        '30D': 'Birthday count',
        '32D': 'Lays eyes on',
        '35D': 'Take to court',
        '37D': 'Dessert in a tin, often apple',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0039 — "Sleigh Bells" (18 blocks)
const FULL_0039 = buildPuzzle({
    id: 'full-0039',
    size: 'full',
    difficulty: 'medium',
    layout: ['GRAB##VISTA', 'REBUS#ANNUL', 'APART#SKATE', 'DETRACT#FOR', 'SLEIGH#HURT', '###TEASE###', 'INTO#SPARKS', 'SEE#VERDANT', 'SENSE#APNEA', 'UDDER#TIGER', 'ESSAY##NEST'],
    title: 'Sleigh Bells',
    clues: {
        '1A': 'Take hold of quickly',
        '5A': 'A sweeping view',
        '10A': 'Picture puzzle that spells a word or phrase',
        '12A': 'Declare null and void',
        '13A': 'Separated by distance',
        '14A': 'Glide on the ice',
        '15A': 'Take away (from)',
        '17A': '"This is ___ you," said the gift-giver',
        '18A': 'What dashes through the snow',
        '19A': 'In pain',
        '20A': 'Gently poke fun at a friend',
        '22A': 'Heading toward the inside of',
        '25A': 'What flint and steel make',
        '29A': 'Take notice of with your eyes',
        '30A': 'Lush and green',
        '31A': 'Feeling in your bones',
        '33A': 'A pause in breathing during sleep',
        '34A': 'Where the milk comes from',
        '35A': 'The striped big cat',
        '36A': 'A short written composition',
        '37A': 'A cozy home built by a bird',
        '1D': 'June\'s cap-and-gown crowd, for short',
        '2D': 'Drive back',
        '3D': 'Die down, as a storm',
        '4D': 'A well-wrapped Mexican meal',
        '5D': 'Stretching far and wide',
        '6D': 'What fills a fountain pen',
        '7D': 'A grand mix-up, in old Army slang',
        '8D': 'A pupil’s private teacher',
        '9D': 'On watch and ready, or a warning signal',
        '11D': 'Where the play unfolds',
        '16D': 'Run after',
        '19D': 'The bowler\'s front target',
        '21D': 'Small herring-like fish',
        '22D': 'A matter or topic up for discussion',
        '23D': 'Must-haves',
        '24D': 'Looks after',
        '26D': 'A whole stretch, from low to high',
        '27D': 'Joints in the middle of your legs',
        '28D': 'Get going',
        '30D': 'To a high degree',
        '32D': 'Large body of salt water',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0040 — "Photo Albums" (18 blocks)
const FULL_0040 = buildPuzzle({
    id: 'full-0040',
    size: 'full',
    difficulty: 'medium',
    layout: ['#BEAR#SMART', 'GRAVE#WIDOW', 'RAGED#ALIBI', 'OVER#SPLEEN', 'WORSHIP#USE', '###EATEN###', 'SEA#MEDICAL', 'ALBUMS#MADE', 'GUISE#ABBAS', 'ADDER#CLIPS', 'SEEDS#TENT#'],
    title: 'Photo Albums',
    clues: {
        '1A': 'Grin and ___ it',
        '5A': 'Sharp as a tack',
        '10A': 'Serious and solemn, as a tone of voice',
        '11A': 'Woman whose husband has passed on',
        '12A': 'Stormed and thundered',
        '13A': 'Proof of being elsewhere when something happened',
        '14A': 'Above; finished, as a game',
        '15A': 'Ill temper, vented',
        '16A': 'Bow the head in reverence',
        '18A': 'Put to good ___, make the most of',
        '19A': 'Consumed at the dinner table',
        '21A': 'The salty blue expanse',
        '24A': 'Having to do with doctors\' work',
        '28A': 'Where old photos live',
        '30A': 'Created or produced',
        '31A': 'An outward disguise',
        '32A': 'Religious leaders in some traditions',
        '33A': 'A common garden snake',
        '34A': 'Fastens papers together',
        '35A': 'What you plant to grow flowers',
        '36A': 'Canvas shelter pitched at a campsite',
        '1D': 'Cheer of approval, often shouted at the opera',
        '2D': 'Keen and excited to begin',
        '3D': 'Strongly opposed and unwilling',
        '4D': 'The color of a ripe tomato',
        '5D': 'Traded straight across',
        '6D': 'Where grain becomes flour',
        '7D': 'Farewell, in French',
        '8D': 'Loose garments worn after a bath',
        '9D': 'Sturdy string for parcels',
        '10D': 'What gardens do with care',
        '15D': 'Locations or building plots',
        '17D': 'They drive the nails home',
        '20D': 'Quick as Jack over the candlestick',
        '21D': 'Long tales of heroes',
        '22D': 'Slip away from a pursuer',
        '23D': 'Put up with; tolerate',
        '25D': 'A log house in the woods',
        '26D': 'The very heart of the matter',
        '27D': 'A smaller amount',
        '29D': 'Not brand new; previously owned',
        '32D': 'A part of a play',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0041 — "Busy Bees" (18 blocks)
const FULL_0041 = buildPuzzle({
    id: 'full-0041',
    size: 'full',
    difficulty: 'hard',
    layout: ['SCRUB#START', 'ALONE#WIDOW', 'CADRE#ALIBI', 'KNEE#SPLEEN', '#GOSSIP#USE', '###TILES###', 'MOM#ELDEST#', 'APIARY#ACID', 'DEMUR#PROMO', 'ARENA#ACRES', 'MASTS#THESE'],
    title: 'Busy Bees',
    clues: {
        '1A': 'Give a good hard washing',
        '6A': 'Get going',
        '11A': 'With no company',
        '12A': 'Woman whose husband has passed on',
        '13A': 'A tight inner circle',
        '14A': 'Proof of where you were at the time',
        '15A': 'The bend in your leg',
        '16A': 'Ill temper, vented',
        '17A': 'Idle chatter about others',
        '19A': 'Put to work or make ___ of',
        '20A': 'Flat squares on a kitchen floor',
        '22A': 'Dad\'s better half, say the kids',
        '25A': 'First-born of the family',
        '28A': 'Where the beekeeper works',
        '30A': 'Sour liquid, the opposite of a base in chemistry',
        '32A': 'Politely object',
        '33A': 'A station\'s plug for itself',
        '34A': 'Big stadium where games are played',
        '35A': 'Units of farmland',
        '36A': 'A schooner\'s tall poles',
        '37A': 'Word pointing at this group right here',
        '1D': 'Burlap bag for potatoes, or to dismiss from a job',
        '2D': 'The sound of the trolley bell',
        '3D': 'Cowboy show with bucking broncos',
        '4D': 'Rumblings of discontent',
        '5D': 'Buzzing honey-maker',
        '6D': 'Traded straight across',
        '7D': 'Work the soil; the cash drawer',
        '8D': 'A fond farewell',
        '9D': 'Loose garments worn after a bath',
        '10D': 'Sturdy string for parcels',
        '16D': 'Full of nonsense',
        '18D': 'Rugged Western mountain ranges',
        '21D': 'Hunt high and low',
        '22D': 'A polite address for a lady',
        '23D': 'A grand musical drama, sung throughout',
        '24D': 'Performers who never say a word',
        '26D': 'The points each team has in a game',
        '27D': 'Multiplication signs, or \'three ___ four\'',
        '29D': 'Mother\'s sister',
        '31D': 'One spoonful of medicine',
        '33D': 'A gentle tap; a bit of butter',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0042 — "Daily Errands" (18 blocks)
const FULL_0042 = buildPuzzle({
    id: 'full-0042',
    size: 'full',
    difficulty: 'medium',
    layout: ['SMILE#SCARF', 'TONER#PACER', 'UTTER#ARENA', 'FOR#AIR#RAM', 'FROWNS#ABLE', '###IDLED###', 'EVEN#ERSATZ', 'RAY#USE#LIE', 'ALIAS#COILS', 'SINCE#TWEET', 'EDGED#SENDS'],
    title: 'Daily Errands',
    clues: {
        '1A': 'What "cheese" produces',
        '6A': 'Winter neck-warmer',
        '11A': 'Ink powder cartridge for a copier',
        '12A': 'A harness-racing horse',
        '13A': 'Speak words aloud',
        '14A': 'A large stadium for sports or shows',
        '15A': '\'This gift is ___ you\'',
        '16A': 'What you breathe',
        '18A': 'A male sheep',
        '19A': 'Turns the smile upside down',
        '21A': 'Up to the task; capable',
        '22A': 'Sat unused, as an engine',
        '24A': 'Level and flat, or a number divisible by two',
        '27A': 'Substitute, as wartime coffee',
        '31A': 'A beam of sunshine',
        '32A': 'Make ___ of, put to a purpose',
        '33A': 'A fib; or stretch out',
        '34A': 'A false name a person goes by',
        '36A': 'Loops of garden hose',
        '38A': 'From a past time up to now',
        '39A': 'A little bird\'s peep',
        '40A': 'Inched (forward)',
        '41A': 'Drops in the mailbox',
        '1D': 'Odds and ends',
        '2D': 'The engine',
        '3D': 'The opening of a book, for short',
        '4D': 'Sheltered side, away from the wind',
        '5D': 'A quick trip to the store',
        '6D': 'Trade light blows, as boxers warming up',
        '7D': 'It rolls down the road',
        '8D': 'Sharp and bitter in tone',
        '9D': 'Having to do with the kidneys',
        '10D': 'What a picture hangs in',
        '17D': 'Little islands',
        '20D': 'Come out on top',
        '21D': 'Notices in the newspaper selling things, for short',
        '23D': 'Puts up, as a barn',
        '24D': 'Rub out, as pencil marks',
        '25D': 'Holding up under scrutiny',
        '26D': 'Watching with interest',
        '28D': 'From another world entirely',
        '29D': 'Covered with flat squares, as a floor',
        '30D': 'Grates the lemon peel',
        '32D': 'Worn out, like a secondhand car',
        '35D': 'Playing card just above the two',
        '37D': 'Be in debt',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0043 — "On the Green" (18 blocks)
const FULL_0043 = buildPuzzle({
    id: 'full-0043',
    size: 'full',
    difficulty: 'hard',
    layout: ['GRAPE#MACHO', 'RALLY#INLET', 'ARGUE#STILT', 'SEAM#TRIFLE', 'PREPARE#FOR', '####VIA####', 'AND#ABDOMEN', 'BIRDIE#ROLE', 'AFOUL#ADOBE', 'STOKE#RESOD', 'HYPED#CREWS'],
    title: 'On the Green',
    clues: {
        '1A': 'One of a vineyard bunch',
        '6A': 'Tough-guy in manner',
        '11A': 'Come roaring back',
        '12A': 'Narrow waterway leading into a bay',
        '13A': 'Have a heated disagreement',
        '14A': 'One of a circus walker\'s tall poles',
        '15A': 'Where two pieces of cloth meet',
        '16A': 'A small matter; an English dessert',
        '17A': 'Get ready',
        '19A': '\'Three cheers ___ the winner!\'',
        '20A': 'By way of; passing through',
        '21A': 'Bread ___ butter',
        '24A': 'The midsection',
        '29A': 'One under par',
        '31A': 'An actor\'s part',
        '32A': 'Tangled up or in trouble with',
        '33A': 'Sun-dried mud brick used in Southwest homes',
        '34A': 'Feed the fire',
        '35A': 'Lay fresh turf',
        '36A': 'All worked up, in slang',
        '37A': 'Ships\' companies',
        '1D': 'A firm hold; understanding',
        '2D': 'Harder to come by',
        '3D': 'Slimy green growth on a pond',
        '4D': 'Pleasingly well-rounded',
        '5D': 'You see with it',
        '6D': 'Got the wrong idea from',
        '7D': 'Against (prefix)',
        '8D': 'A sheer rock face',
        '9D': 'A friendly greeting',
        '10D': 'Furry animal that floats on its back and cracks shells',
        '16D': 'A family or a folk grouping',
        '18D': '"___ oneself of" (made use of)',
        '21D': 'Embarrass into silence',
        '22D': 'Clever and neat',
        '23D': 'Sag like a thirsty flower',
        '25D': 'Tidy arrangement, or a command in a restaurant',
        '26D': 'Large antlered animal of the north woods',
        '27D': 'The joint in the middle of your arm',
        '28D': 'Must-haves',
        '30D': 'A notch above a marquis',
        '33D': 'Part of a circle\'s curve',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0044 — "Scenic Overlook" (18 blocks)
const FULL_0044 = buildPuzzle({
    id: 'full-0044',
    size: 'full',
    difficulty: 'easy',
    layout: ['WAVE#ANTLER', 'AWAY#DERIVE', 'TALE#STAKES', 'TRUST##VENT', 'SEE#ASCENTS', '###SPELL###', 'PLATEAU#BUT', 'RAGE##BORNE', 'ENGAGE#NOTE', 'SAILOR#TWIN', 'SIESTA#ONLY'],
    title: 'Scenic Overlook',
    clues: {
        '1A': 'A friendly flap of the hand',
        '5A': 'A buck\'s branching crown',
        '11A': 'Far off in the distance',
        '12A': 'Draw, as a conclusion',
        '13A': 'A story told to children at bedtime',
        '14A': 'Tomato plants\' supports; what\'s wagered',
        '15A': 'Take on faith',
        '17A': 'Where the warm air comes out',
        '18A': 'Use your eyes to look',
        '19A': 'Climbs up the mountain',
        '22A': 'A stretch of weather; put letters in order',
        '23A': 'High flat country; a leveling off',
        '26A': '"All ___ one, and one for all"',
        '29A': 'A towering temper',
        '30A': 'Carried along, as by the wind',
        '32A': 'Take on; promise to marry',
        '35A': 'A short message to remember by',
        '36A': 'One in navy blues',
        '37A': 'One of a look-alike pair',
        '38A': 'An afternoon nap, Spanish style',
        '39A': 'Solely; the ___ one',
        '1D': 'Units on a light bulb',
        '2D': 'Mindful and informed about something',
        '3D': 'What something is worth',
        '4D': 'A sneak peek of what’s coming',
        '5D': 'Newspaper notices selling things',
        '6D': 'What the fisherman casts',
        '7D': 'Go places',
        '8D': 'Compare (to)',
        '9D': 'A happening on the calendar',
        '10D': 'Pauses to catch your breath',
        '16D': 'What mends the torn page',
        '20D': 'Large body of salt water',
        '21D': 'Sandwich with three slices of bread',
        '22D': 'Bargains too good to pass up',
        '23D': 'Newspapers and reporters, collectively',
        '24D': 'Roofed porch in Hawaii',
        '25D': 'A prized striped marble',
        '26D': 'The color of toast done right',
        '27D': 'Right up to the moment of',
        '28D': 'Very tiny indeed',
        '31D': '"I\'m ___ you!" (I see your game)',
        '33D': 'Came into possession of; "I ___ a letter"',
        '34D': 'A long period of history',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0045 — "Turn of Phrase" (18 blocks)
const FULL_0045 = buildPuzzle({
    id: 'full-0045',
    size: 'full',
    difficulty: 'easy',
    layout: ['PLANE#FARES', 'HOLES#OLIVE', 'ROLES#RISEN', 'ASIDES#VENT', 'SEE#NOSE###', 'END#CAN#ASS', '###WERE#SAT', 'HIGH#SETTLE', 'ACRID#ROUTE', 'VOILA#ENTER', 'ENDED#DEEDS'],
    title: 'Turn of Phrase',
    clues: {
        '1A': 'Flying machine with wings and engines',
        '6A': 'Gets along; bus fees',
        '11A': 'Gaps or openings, as in a worn sock',
        '12A': 'Small green or black fruit pressed for oil',
        '13A': 'Parts that actors play on stage',
        '14A': 'Up with the sun',
        '15A': 'Whispered remarks to the audience',
        '17A': 'Where the warm air comes out',
        '18A': 'Catch a glimpse of',
        '19A': 'It knows the roses',
        '21A': 'The finish',
        '22A': 'Tin, on a soup label',
        '23A': 'Donkey, plainly',
        '26A': '"As you ___ saying…"',
        '27A': 'Was seated, in the past tense',
        '28A': 'Way up tall, like a skyscraper',
        '31A': 'Come to rest; end a dispute',
        '33A': 'Sharp and bitter to the nose or taste',
        '35A': 'The path you take to get there',
        '36A': '"And there you have it!"',
        '37A': 'Go in through the door',
        '38A': 'Brought to a close',
        '39A': 'Heroic acts; legal documents',
        '1D': '"A turn of ___"',
        '2D': 'Slack off, as a belt after dinner',
        '3D': 'Joined in common cause',
        '4D': 'Must have',
        '5D': 'Quietly tapped, as a sonar signal',
        '6D': 'In favor of, as a vote ___ a plan',
        '7D': 'Still breathing and well',
        '8D': 'What the sun and bread dough both do',
        '9D': 'Smooth and level, or a tied score',
        '10D': 'Calendar units of twenty-four hours',
        '16D': 'Rides the updrafts like an eagle',
        '20D': 'Curled a scornful lip',
        '23D': 'Sharp-witted',
        '24D': 'Seasoned from the shaker',
        '25D': 'Points the car; ranch cattle',
        '26D': 'For a ___ (for a stretch of time)',
        '28D': 'To own or possess something',
        '29D': 'A revered image',
        '30D': 'The crossword\'s framework',
        '32D': 'The mood of a voice, or a shade of color',
        '34D': 'Father, fondly',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0046 — "Garden Terrace" (18 blocks)
const FULL_0046 = buildPuzzle({
    id: 'full-0046',
    size: 'full',
    difficulty: 'medium',
    layout: ['CLASP##COPS', 'RAWER#BORIC', 'ABATE#AUGER', 'FOR#TERRACE', 'TREATY#ANEW', '###DYING###', 'HERD#NEEDED', 'AVERAGE#EVE', 'SEVER#DEPOT', 'TRUST#LATKE', 'EYES##ETHER'],
    title: 'Garden Terrace',
    clues: {
        '1A': 'Hold tightly, as in a handshake',
        '6A': 'The police, informally',
        '10A': 'Less cooked',
        '11A': 'Kind of acid in old eyewash',
        '12A': 'Die down, as a storm',
        '13A': 'A tool that bores holes',
        '14A': '\'Once and ___ all\'',
        '15A': 'A paved garden sitting spot',
        '17A': 'A formal peace on paper',
        '19A': 'Once more; starting fresh',
        '20A': 'Fading fast, as embers',
        '22A': 'The whole drove of cattle',
        '25A': 'Called for',
        '29A': 'Neither the best nor the worst',
        '31A': 'The day before a holiday',
        '32A': 'Cut clean through',
        '33A': 'The old train station',
        '35A': 'Take on faith',
        '36A': 'Potato pancake of Hanukkah',
        '37A': 'A pair of peepers',
        '38A': 'Old-time operating-room anesthetic',
        '1D': 'Skill at making things by hand',
        '2D': 'A day\'s honest toil',
        '3D': 'Mindful and informed about something',
        '4D': 'Put in place, as a table for dinner',
        '5D': 'Easy on the eyes; fairly',
        '6D': 'What the Cowardly Lion went to find',
        '7D': 'Pipe instrument found in many churches',
        '8D': 'A slice of cake, or a single part of a set',
        '9D': 'It turns to the right to tighten',
        '11D': 'Soap unit, or a tavern',
        '16D': 'Watching with interest',
        '18D': 'Where the mail finds you; speak to a crowd',
        '21D': 'What the haystack famously hides',
        '22D': 'A great rush and hurry',
        '23D': 'Each and all of them',
        '24D': 'A stage show of songs and skits',
        '26D': 'How far down the well goes',
        '27D': 'Call to mind',
        '28D': 'Discourage from trying',
        '30D': 'What hangs in a gallery',
        '34D': 'Have a bite of breakfast or lunch',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0047 — "Main Street" (18 blocks)
const FULL_0047 = buildPuzzle({
    id: 'full-0047',
    size: 'full',
    difficulty: 'medium',
    layout: ['LASH#HERALD', 'IDLE#AVENUE', 'TIER#DESIRE', 'HEEDS##USED', 'OUT#USELESS', '###GREAT###', 'STREETS#ASS', 'KEEL##YOUTH', 'INTACT#IDEA', 'MORTAR#LIAR', 'SNOOTY#YOKE'],
    title: 'Main Street',
    clues: {
        '1A': 'Strike of a whip, or part of the eye\'s fringe',
        '5A': 'A messenger with news',
        '11A': 'Doing nothing; at rest',
        '12A': 'A broad city street',
        '13A': 'One layer of the wedding cake',
        '14A': 'A deep wish',
        '15A': 'Pays mind to',
        '17A': 'Not new; a secondhand item',
        '18A': 'Away from home, as when running errands',
        '19A': 'Of no help at all',
        '22A': '"___ Scott!"',
        '23A': 'What a city map shows',
        '26A': 'Stubborn beast of burden',
        '29A': 'The bottom ridge running along a boat\'s hull',
        '30A': 'The springtime of life',
        '32A': 'All in one piece',
        '35A': 'A bright thought',
        '36A': 'What holds the bricks together',
        '37A': 'One who does not tell the truth',
        '38A': 'Nose-in-the-air haughty',
        '39A': 'What joins a team of oxen',
        '1D': 'Print pulled from a stone, for short',
        '2D': 'Fond farewell, borrowed from French',
        '3D': 'Winter\'s icy rain',
        '4D': 'The whole drove of cattle',
        '5D': 'Owned, in the past',
        '6D': 'The night before a holiday',
        '7D': 'What comes of an effort',
        '8D': 'Licorice-flavoured seed',
        '9D': 'A tackle box\'s shiny temptations',
        '10D': 'Heroic acts; legal documents',
        '16D': 'Confident and certain',
        '20D': 'Place down in position',
        '21D': 'Simple and free of trouble',
        '22D': 'Italy\'s silky ice cream',
        '23D': 'Reads quickly; takes the cream off',
        '24D': 'The tongue in a carpenter\'s joint',
        '25D': 'In a style from years gone by',
        '26D': 'The sound half of a broadcast',
        '27D': 'What sizzles under the broiler',
        '28D': 'Go halves on',
        '31D': 'Greasy; slick with grease',
        '33D': 'Whiskered pet that purrs on your lap',
        '34D': 'An old title for a Turkish governor',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0048 — "Beauty Sleep" (18 blocks)
const FULL_0048 = buildPuzzle({
    id: 'full-0048',
    size: 'full',
    difficulty: 'easy',
    layout: ['#DATA#CASES', 'LOVES#ARENA', 'IDEAL#TRIAL', 'FOR#ESSENCE', 'ESTEEM#SETS', '###APART###', 'HATS#RESULT', 'AGITATE#SUE', 'RATER#LEARN', 'SPARE#EGGED', 'HENNA#DOES#'],
    title: 'Beauty Sleep',
    clues: {
        '1A': 'Facts and figures gathered for study',
        '5A': 'A lawyer\'s workload',
        '10A': 'Cherishes and adores deeply',
        '11A': 'A ring or stadium for a show',
        '12A': 'Just right for the purpose',
        '13A': 'A test run before the real thing',
        '14A': 'In support of; meant to be given to',
        '15A': 'Quietly tapped, as a sonar signal',
        '17A': 'High regard',
        '19A': 'Places where you sit, as in a theater',
        '20A': 'Split up, no longer together',
        '22A': 'Derbies and bonnets',
        '25A': 'What comes of an effort',
        '29A': 'Stir up',
        '31A': 'Take to court',
        '32A': 'One handing out the stars',
        '33A': 'Pick up new knowledge',
        '35A': 'The extra one kept in reserve',
        '36A': '"___ on" (urged)',
        '37A': 'A reddish dye used to color hair',
        '38A': 'Bucks\' mates',
        '1D': 'Famously extinct birds',
        '2D': 'Head off, as disaster',
        '3D': 'Afternoon cuppa',
        '4D': 'Off in dreamland',
        '5D': 'Tabbies and toms',
        '6D': 'Takes into custody',
        '7D': 'Fishing net, or a river through Paris',
        '8D': 'Pass into law; also, act out',
        '9D': 'Goods sold at a shop; a store\'s earnings',
        '10D': 'The years from birth to old age',
        '16D': 'Sharp as a tack',
        '18D': 'Toward the sunrise',
        '21D': 'Wound in the catch; staggered',
        '22D': 'Rough and unkind in tone',
        '23D': 'Selfless, loving kindness, an old Greek term',
        '24D': 'A giant; a heavyweight of industry',
        '26D': 'The way a word is normally used',
        '27D': 'A tackle box\'s shiny temptations',
        '28D': 'Look after, as a garden or a fire',
        '30D': 'Region or neighbourhood',
        '34D': 'One\'s pride or self-regard',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0049 — "Sailing East" (18 blocks)
const FULL_0049 = buildPuzzle({
    id: 'full-0049',
    size: 'full',
    difficulty: 'easy',
    layout: ['SCARE#STEAM', 'TODAY#CHAFE', 'ALONE#RESOD', 'FOR#SEE#ERA', 'FREE#VESSEL', '###ARENA###', 'SULTAN#YEAR', 'ONE#ITS#AGE', 'AMASS#ORGAN', 'REVUE#RELIT', 'STEED#EVENS'],
    title: 'Sailing East',
    clues: {
        '1A': 'Give a fright',
        '6A': 'Vapor that rises from a boiling kettle',
        '11A': 'This very day',
        '12A': 'Rub raw',
        '13A': 'With no company',
        '14A': 'Lay fresh turf',
        '15A': '\'This bouquet is ___ you\'',
        '16A': 'Lay eyes upon',
        '18A': 'A long age or span of time',
        '19A': 'At no cost',
        '21A': 'A ship; a pitcher',
        '23A': 'The ring where the big match is held',
        '25A': 'A ruler of old Turkey',
        '28A': 'Twelve months on the calendar',
        '32A': 'The loneliest number',
        '33A': 'Belonging to it',
        '35A': 'How old you are',
        '36A': 'Pile up over time',
        '38A': 'Pipe instrument heard in church',
        '40A': 'A stage show of songs and skits',
        '41A': 'Touched a match to again',
        '42A': 'Noble horse of a knight',
        '43A': 'Comes out level, as a tied score',
        '1D': 'The team and crew of an office',
        '2D': 'What crayons add',
        '3D': 'Cherish and love deeply',
        '4D': 'Went on foot, quickly',
        '5D': 'What spectacles help',
        '6D': 'Where the picture shows at the movies',
        '7D': 'A little word before a noun',
        '8D': 'Lets up little by little',
        '9D': 'Before, in old-fashioned verse',
        '10D': 'What hangs from a champion\'s ribbon',
        '17D': 'A happening, like a party or concert',
        '20D': 'Have a bite of food',
        '22D': 'Speak your piece',
        '24D': 'Brought up',
        '25D': 'Rides the updrafts like an eagle',
        '26D': 'Still unfulfilled, as a goal',
        '27D': 'Go away; depart',
        '29D': 'Majestic bird and symbol of America',
        '30D': 'Yet another time',
        '31D': 'Monthly payments a tenant makes',
        '34D': 'Tender after a workout',
        '37D': 'Take to court',
        '39D': 'Gun, as an engine',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0050 — "Song and Verse" (18 blocks)
const FULL_0050 = buildPuzzle({
    id: 'full-0050',
    size: 'full',
    difficulty: 'hard',
    layout: ['TWILL#DATES', 'HONEY#OLIVE', 'ORDER#EBBED', 'USE#ISSUING', '#EXACT#MATE', '###USAGE###', 'HAND#GONGS#', 'AVOIDED#LAB', 'RABBI#STAVE', 'PILLS#OOZED', 'SLEEK#NEEDS'],
    title: 'Song and Verse',
    clues: {
        '1A': 'Diagonal-weave fabric',
        '6A': 'Days marked on the calendar',
        '11A': 'Sweet syrup the bees make',
        '12A': 'A small green or black fruit, often in salads',
        '13A': 'A neat sequence, or a command for food',
        '14A': 'Went out, as the tide',
        '15A': 'Put to work; make good of',
        '16A': 'Sending out officially',
        '18A': 'Precise and accurate to the last detail',
        '20A': 'Close companion or chess move shout',
        '21A': 'The way something is used',
        '23A': 'It fits in your palm and holds things',
        '26A': 'What dinner is announced with, grandly',
        '29A': 'Steered clear of',
        '31A': 'Where chemists work, for short',
        '33A': 'Leader of a synagogue',
        '34A': 'Part of a fence, or a board in a barrel\'s side',
        '36A': 'What the weekly organizer organizes',
        '37A': 'Seeped slowly out',
        '38A': 'Smooth as a seal\'s coat',
        '39A': 'Must-haves',
        '1D': 'The old word for "you"',
        '2D': 'Further from better',
        '3D': 'Alphabetical list at the back of a book',
        '4D': 'The sheltered side, away from the wind',
        '5D': 'The words to the song',
        '6D': 'Bucks\' mates',
        '7D': 'The white of an egg',
        '8D': 'The larger bone in your lower leg',
        '9D': 'A wedding or a concert, for instance',
        '10D': 'Grassy plant found along marshy banks',
        '17D': 'Where the play unfolds',
        '19D': 'Loud enough to hear',
        '22D': 'A boy one sponsors at the font',
        '23D': 'Angels\' instruments, in pictures',
        '24D': 'To be of use or help',
        '25D': 'Grand and dignified, like a lord',
        '27D': 'The shine on a doughnut',
        '28D': 'Kept from harm or set aside, in past tense',
        '30D': 'A flat round plate',
        '32D': 'Where the tulips are planted',
        '35D': 'Little piggy, in the rhyme',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0051 — "Keepsake Box" (18 blocks)
const FULL_0051 = buildPuzzle({
    id: 'full-0051',
    size: 'full',
    difficulty: 'medium',
    layout: ['AMISS#MORAL', 'CONCH#EVADE', 'EVERY#MEDIA', 'RIPE#SERIES', 'BETWEEN#OUT', '####ACT####', 'ART#STOMACH', 'BOASTS#AREA', 'BASTE#PRODS', 'ASTIR#ASSET', 'STERN#THESE'],
    title: 'Keepsake Box',
    clues: {
        '1A': 'Not on target, as a missed shot',
        '6A': 'The lesson at the end of a fable',
        '11A': 'The shell you hold to your ear',
        '12A': 'Dodge or escape, as a question',
        '13A': 'Each and all, without exception',
        '14A': 'Newspapers, radio, and television together',
        '15A': 'Ready to be picked, as fruit',
        '16A': 'A set of episodes in a row',
        '17A': 'In the gap separating two things',
        '19A': 'No longer in the game, in baseball',
        '20A': 'Do something, or a play’s division',
        '21A': 'What hangs in a gallery',
        '24A': 'Where butterflies flutter',
        '29A': 'Toots one\'s own horn',
        '31A': 'A region or zone',
        '32A': 'Brush a roast with its own juices',
        '33A': 'Gives a nudge',
        '34A': 'Up and moving about',
        '35A': 'A handy thing of value',
        '36A': 'Strict and no-nonsense; also a boat’s back end',
        '37A': '"___ days are the best," pointing nearby',
        '1D': 'Sharp and bitter in tone or taste',
        '2D': 'A night at the pictures',
        '3D': 'All thumbs',
        '4D': 'It turns to the right to tighten',
        '5D': 'Bashful and timid',
        '6D': 'A keepsake',
        '7D': 'Across the top of; above',
        '8D': 'Box that brings music and news',
        '9D': 'A fond farewell, French-style',
        '10D': 'The smallest amount, as in "the very ___"',
        '16D': 'Branches of a faith',
        '18D': 'Toward the sunrise',
        '21D': 'Religious leaders in certain faiths',
        '22D': 'Cook a chicken in the oven',
        '23D': 'What the tongue does to soup',
        '25D': 'Boggy ground where reeds grow',
        '26D': 'Got up; came about',
        '27D': 'Gives up formally',
        '28D': 'A great rush and hurry',
        '30D': 'Work the spoon',
        '33D': 'A gentle tap; a bit of butter',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0052 — "Starry Night" (18 blocks)
const FULL_0052 = buildPuzzle({
    id: 'full-0052',
    size: 'full',
    difficulty: 'hard',
    layout: ['SATES#APSES', 'TROVE#BLAME', 'AGREE#LANCE', 'BUT#SLENDER', '#ESSAY#EYES', '###TWIST###', 'SPAR#NASAL#', 'COMINGS#BIO', 'ALIKE#HAIKU', 'RAGES#ELDER', 'FROST#SLEDS'],
    title: 'Starry Night',
    clues: {
        '1A': 'Fills up fully, as a big meal does',
        '6A': 'Curved ends of cathedrals',
        '11A': 'A hidden hoard of treasure',
        '12A': 'Point the finger at',
        '13A': 'To be of the same mind',
        '14A': 'Long spear once used by knights',
        '15A': '\'Last ___ not least\'',
        '16A': 'Willow-thin',
        '18A': 'A short written composition',
        '20A': 'What you see with',
        '21A': 'A dance craze of the early sixties',
        '23A': 'Trade light blows, as boxers warming up',
        '26A': 'Spoken through the nose, like a stuffy voice',
        '29A': '"___ and goings"',
        '31A': 'A life story, for short',
        '33A': 'Two peas in a pod are this',
        '34A': 'A poem of seventeen syllables',
        '36A': 'Storms about angrily',
        '37A': 'The older of two, or a respected senior',
        '38A': 'What October mornings leave on the lawn',
        '39A': 'Winter hill riders',
        '1D': 'A quick thrust, or a rough attempt',
        '2D': 'Have a heated disagreement',
        '3D': 'Cases in a civil courtroom',
        '4D': 'The day before a holiday',
        '5D': 'The playground\'s up-and-down ride',
        '6D': 'Capable; skilled enough to do something',
        '7D': 'Mars and Jupiter, for two',
        '8D': 'Like a beach picnic blanket',
        '9D': 'Host who keeps a show moving along',
        '10D': 'Wise prophets who foretell',
        '17D': 'Stretched out flat; fibbing',
        '19D': 'A perfect bowling game is twelve of them',
        '22D': 'Beauty queens\' ribbons',
        '23D': 'Winter neck-warmer',
        '24D': 'Like the great white bear',
        '25D': 'Friend, south of the border',
        '27D': 'Stick to, as the rules',
        '28D': 'Found agreeable',
        '30D': 'A bird\'s cozy home for its eggs',
        '32D': 'Belonging to us',
        '35D': 'Every bit of it',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0053 — "Twice-Told Tales" (18 blocks)
const FULL_0053 = buildPuzzle({
    id: 'full-0053',
    size: 'full',
    difficulty: 'easy',
    layout: ['STUDS#TREAD', 'TULIP#HELLO', 'UTTER#OVALS', 'FOR#YOU#TOE', 'FRAYED#SETS', '###ERODE###', 'MOST#RETOLD', 'ERA#USE#PER', 'ABUTS#PEEVE', 'NICHE#LYRES', 'STEED#YEARS'],
    title: 'Twice-Told Tales',
    clues: {
        '1A': 'Snaps on a western shirt; wall timbers',
        '6A': 'The grooved surface of a tire',
        '11A': 'Bright spring flower grown from a bulb',
        '12A': 'A friendly greeting',
        '13A': 'Say out loud',
        '14A': 'Racetrack shapes',
        '15A': '\'These flowers are ___ you\'',
        '16A': 'The person being spoken to',
        '18A': 'Little piggy, in the rhyme',
        '19A': 'Worn at the edges',
        '21A': 'Places where you sit, as in a theater',
        '22A': 'Wear away, as rock by water',
        '24A': 'The greatest amount',
        '27A': 'Passed down again, as a family story',
        '31A': 'A long period of history',
        '32A': 'Make practical of; employ',
        '33A': 'For each, in pricing',
        '34A': 'Borders right up against',
        '36A': 'A pet annoyance or sore spot',
        '38A': 'A snug little corner of one\'s own',
        '39A': 'Small harps of ancient Greece',
        '40A': 'Noble horse of a knight',
        '41A': 'Birthday count',
        '1D': 'Odds and ends',
        '2D': 'A pupil’s private teacher',
        '3D': 'Extreme; far beyond the ordinary',
        '4D': 'One of a pair of dice',
        '5D': 'More nimble for one\'s age',
        '6D': 'The old word for "you"',
        '7D': 'Gun, as an engine',
        '8D': 'To fill with great joy',
        '9D': 'Portion out',
        '10D': 'Spoonfuls of medicine',
        '17D': 'What the nose reports',
        '20D': 'Up to now',
        '21D': 'Adjust a clock to the right time',
        '23D': 'From the bottom of the heart',
        '24D': 'Intends; the wherewithal',
        '25D': 'A moon’s path around a planet',
        '26D': 'Gravy or tasty topping for pasta and meat',
        '28D': 'A grand stage drama set to music',
        '29D': 'A bar used to pry something open',
        '30D': 'Sunday best attire',
        '32D': 'Pre-owned, like a secondhand car',
        '35D': 'A little word before "end" and "best"',
        '37D': 'What you see with',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0054 — "Words of Wisdom" (18 blocks)
const FULL_0054 = buildPuzzle({
    id: 'full-0054',
    size: 'full',
    difficulty: 'easy',
    layout: ['MATH##SPLAT', 'AFOOT#CRIME', 'YOUTH#HONOR', 'BUT#ELEVENS', 'ELSE#EMERGE', '###LEVER###', 'SPHERE#BABE', 'TREMOLO#FOR', 'EARED#ULTRA', 'ATONE#TEENS', 'DENTS##TREE'],
    title: 'Words of Wisdom',
    clues: {
        '1A': 'Sums and times tables',
        '5A': 'The sound of a dropped pie',
        '10A': '"The game is ___!"',
        '12A': 'A wrongdoing the law forbids',
        '13A': 'The springtime of life',
        '14A': 'Hold in high regard',
        '15A': 'On the contrary; however',
        '16A': 'What two ones side by side make',
        '18A': 'Otherwise; if not',
        '20A': 'Come out into the open',
        '21A': 'A bar used to pry or lift',
        '23A': 'A perfectly round solid',
        '26A': 'A wee one, in an old phrase',
        '30A': 'A trembling musical effect',
        '32A': 'Three cheers ___ the winner!',
        '33A': 'Having ears, as some owls look',
        '34A': 'Extreme; far beyond the ordinary',
        '36A': 'Make amends',
        '37A': 'Youngsters aged thirteen to nineteen',
        '38A': 'What hail leaves on the hood',
        '39A': 'It grows tall and gives shade',
        '1D': 'Neither yes nor no',
        '2D': 'Tangled up or in trouble with',
        '3D': 'Talks up loudly',
        '4D': 'Fresh from the oven',
        '5D': 'A crafty plan',
        '6D': 'A short, wise saying',
        '7D': 'Big ocean ship that carries passengers',
        '8D': 'In the middle of',
        '9D': 'Short and to the point',
        '11D': 'Word before "end" or "best"',
        '17D': 'Flat and even, like a still floor',
        '19D': 'Iron or oxygen, on the periodic table',
        '22D': 'Wears away grain by grain',
        '23D': 'In place of, as in "in his ___"',
        '24D': 'Chatter on emptily',
        '25D': 'Long-legged wading bird at the marsh',
        '27D': 'Once the show is over, we\'ll chat ___',
        '28D': 'Carried along, as by the wind',
        '29D': 'Rub out a pencil mark',
        '31D': 'No longer batting, in baseball',
        '35D': 'Permit; rent out',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0055 — "Museum Day" (18 blocks)
const FULL_0055 = buildPuzzle({
    id: 'full-0055',
    size: 'full',
    difficulty: 'easy',
    layout: ['PHASE#ACTS#', 'RIFTS#CHIPS', 'OPTIC#TITLE', 'OPERAS#CHAT', 'FOR#POCKETS', '###MENUS###', 'PLAUDIT#OUT', 'AIMS#COSINE', 'SKIES#FOLDS', 'SEGUE#FLEET', '#SOME#SORRY'],
    title: 'Museum Day',
    clues: {
        '1A': 'A stage or step in a process',
        '6A': 'Plays on a stage; "___ up" (gets going)',
        '10A': 'Splits between old friends',
        '11A': 'Poker pieces; fish\'s partner',
        '13A': 'Having to do with the eye',
        '14A': 'A book\'s name',
        '15A': 'Grand nights at the Met',
        '17A': 'A friendly little conversation',
        '18A': '"Reach ___ the stars"',
        '19A': 'Where hands warm on a cold walk',
        '21A': 'What diners study first',
        '22A': 'A round of praise',
        '25A': 'Not at home; away from the inside',
        '28A': 'Sets one\'s sights',
        '29A': 'A trigonometry ratio',
        '31A': 'What forecasts call partly cloudy',
        '33A': 'Creases the napkins; gives up the hand',
        '34A': 'Smoothly move from one tune right into the next',
        '35A': 'The navy\'s ships; quick on one\'s feet',
        '36A': 'A handful; "___ folks"',
        '37A': 'Word said when you feel regret',
        '1D': 'What the pudding provides, in the saying',
        '2D': 'The river horse of Africa',
        '3D': 'Later than',
        '4D': 'Work the spoon',
        '5D': 'Got away',
        '6D': 'Take the stage',
        '7D': 'Fuzzy new arrivals in the henhouse',
        '8D': 'Old-fashioned gift of a tenth to the church',
        '9D': 'The sound of a dropped pie',
        '12D': 'Places where you sit, as in a theater',
        '16D': 'Speedy blue video-game hedgehog',
        '20D': 'Jeans turned into summer shorts',
        '21D': 'Where the mummies and Monets live',
        '22D': 'Hand along the potatoes',
        '23D': 'Has a taste for',
        '24D': 'Friend, south of the border',
        '25D': 'Worker who greases machine parts',
        '26D': 'Below; beneath',
        '27D': 'Short-tempered',
        '30D': 'A turn in the spotlight alone',
        '32D': 'Use your eyes to look at something',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0056 — "Young Love" (18 blocks)
const FULL_0056 = buildPuzzle({
    id: 'full-0056',
    size: 'full',
    difficulty: 'medium',
    layout: ['ETHIC#MORAL', 'ARENA#EVADE', 'ROAST#MEDIA', 'LOVE#SERIES', '#PERSON#OUT', '###TWITS###', 'SEE#ELOPES#', 'LIEGES#EXAM', 'EGRET#METRO', 'WHINE#ACRID', 'STEER#PHASE'],
    title: 'Young Love',
    clues: {
        '1A': 'The work ___',
        '6A': 'The lesson at the end of a fable',
        '11A': 'Big stadium where games are played',
        '12A': 'Slip away from, as a question',
        '13A': 'Cook a chicken in the oven',
        '14A': 'Newspapers, TV, and radio together',
        '15A': 'Deep, caring affection',
        '16A': 'A set of episodes in a row',
        '17A': 'Any single human being',
        '19A': 'Not inside, in the fresh air',
        '20A': 'Foolish sorts',
        '22A': 'Do you ___ what I mean?',
        '25A': 'Skips the church wedding',
        '28A': 'Lords owed loyalty',
        '30A': 'A big test at the end of a course',
        '32A': 'Tall white wading bird seen in marshes',
        '33A': 'City train that runs underground',
        '34A': 'A complaint in a high, thin voice',
        '35A': 'Bitter and harsh, like a sharp smell',
        '36A': 'Guide the wheel; a ranch animal',
        '37A': 'A stage or step in a process',
        '1D': 'A count of the nobility',
        '2D': 'A scout unit on the march',
        '3D': 'Lift up, as a heavy sigh',
        '4D': 'Slip in',
        '5D': 'Whiskered pet that purrs on your lap',
        '6D': 'A keepsake',
        '7D': 'Finished and done ___ with; completely settled',
        '8D': 'Wireless that brings you music',
        '9D': 'French farewell',
        '10D': 'The smallest amount',
        '16D': 'The dirt and earth where plants grow',
        '18D': 'More like honey',
        '21D': 'Talk given from a podium',
        '22D': 'Great heaps',
        '23D': 'A figure skater\'s figure',
        '24D': 'Ghostly and unsettling',
        '26D': 'Something more, beyond the usual',
        '27D': 'Graceful wrapped garments of India',
        '29D': 'A bit of inheritance',
        '31D': 'A manner or method',
        '33D': 'Folded paper guide for finding your way',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0057 — "Cheese Board" (18 blocks)
const FULL_0057 = buildPuzzle({
    id: 'full-0057',
    size: 'full',
    difficulty: 'hard',
    layout: ['USE#LOCATES', 'PAN#ARUGULA', 'PUT#DEPENDS', 'ENEMY##DIES', 'RAREBIT#CRY', '###TULIP###', 'ASH#GLEAMED', 'STAB##PROVE', 'HAVARTI#RAN', 'EROSION#ADS', 'SECEDES#LEE'],
    title: 'Cheese Board',
    clues: {
        '1A': 'Put to good purpose',
        '4A': 'Pins down the whereabouts of',
        '11A': 'It sizzles on the stove',
        '12A': 'Peppery salad green',
        '13A': 'Set in place',
        '14A': '"That ___" (it\'s not so simple)',
        '15A': 'A foe or opponent',
        '17A': 'Peters out, as an engine',
        '18A': 'Melted cheese on toast, Welsh style',
        '21A': 'Weep with tears',
        '22A': 'Cup-shaped spring flower from a bulb',
        '24A': 'What\'s left in the fireplace',
        '27A': 'Shone softly',
        '31A': 'A quick poke or thrust',
        '33A': 'Show beyond doubt that it is true',
        '34A': 'A mild, buttery Danish cheese',
        '37A': 'Went on foot, quickly',
        '38A': 'The slow wearing of wind and water',
        '39A': 'Notices in the newspaper selling things, for short',
        '40A': 'Pulls out of the union; breaks away',
        '41A': 'The sheltered side, out of the wind',
        '1D': 'Top floor, or higher up',
        '2D': 'Hot steam room of Finnish origin',
        '3D': 'Step through the doorway',
        '4D': 'The garden\'s polka-dotted friend',
        '5D': 'Rock worth mining',
        '6D': 'It holds your morning coffee',
        '7D': 'Like a fine wine that has matured',
        '8D': 'Snug pullover top a soldier might wear',
        '9D': 'Older; a flowering shrub with dark berries',
        '10D': 'Full of cheek',
        '16D': 'Was introduced to; "We ___ years ago"',
        '19D': 'Under the weather',
        '20D': 'They keep neckwear in place',
        '23D': 'Average score on a golf hole',
        '24D': 'Gray powder left in the fireplace',
        '25D': 'Look at fixedly with wide eyes',
        '26D': 'Great destruction and chaos',
        '28D': 'The lesson at the end of a fable',
        '29D': 'Dodge or sidestep',
        '30D': 'Thick and crowded together',
        '32D': 'The bag a runner touches',
        '35D': 'Cleared away; got the room free of clutter',
        '36D': 'Little piggy, in the rhyme',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0058 — "Tying the Knot" (18 blocks)
const FULL_0058 = buildPuzzle({
    id: 'full-0058',
    size: 'full',
    difficulty: 'hard',
    layout: ['THESE#RENAL', 'HENNA#EVADE', 'RADAR#TIBIA', 'OVER##ALOES', 'WEDLOCK#BUT', '###SURER###', 'ADS#SYNERGY', 'RELIT##CARE', 'ELATE#LEVEL', 'AFTER#IDEAL', 'STEMS#TENTS'],
    title: 'Tying the Knot',
    clues: {
        '1A': 'The ones right here, not those',
        '6A': 'Having to do with the kidneys',
        '11A': 'A reddish-brown dye used on hair',
        '12A': 'Dodge; slip away from',
        '13A': 'It reads the same both ways — and tracks storms',
        '14A': 'The shinbone',
        '15A': 'Finished and done with',
        '16A': 'Soothing plants for a sunburn',
        '17A': 'The married state',
        '20A': '\'On your mark, get ___, go!\'',
        '21A': 'More confident',
        '23A': 'Newspaper notices selling things',
        '26A': 'The whole outdoing its parts',
        '30A': 'Touched a match to again',
        '32A': 'Look after with kindness',
        '33A': 'To fill with great joy',
        '34A': 'Flat and even, like a still floor',
        '35A': 'Following, in time',
        '36A': 'Just right; a perfect match',
        '37A': 'The stalks that hold up flowers',
        '38A': 'Canvas shelters used for camping',
        '1D': 'Toss the ball across the yard',
        '2D': 'Lift up, as a heavy sigh',
        '3D': 'Brought to a close',
        '4D': 'Tangles in the yarn; growls',
        '5D': 'You hear with it',
        '6D': 'Captured once more',
        '7D': 'Wicked, the opposite of good',
        '8D': 'A rich and powerful bigwig',
        '9D': 'Farewell, in French',
        '10D': 'The smallest bit',
        '18D': 'Removals from office',
        '19D': 'Weep with tears',
        '22D': 'Pull back, as a hairline or a tide',
        '23D': 'Open spaces or fields of study',
        '24D': 'Dutch blue-and-white china',
        '25D': 'Gray rock split for roof tiles',
        '27D': 'Greedy sort, or a bird of ill omen',
        '28D': '"___ Scott!"',
        '29D': 'Uses the outdoor voice',
        '31D': 'One thing on the list',
        '34D': 'Brightly burning, as a candle',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0059 — "Plain and Simple" (18 blocks)
const FULL_0059 = buildPuzzle({
    id: 'full-0059',
    size: 'full',
    difficulty: 'hard',
    layout: ['MATTE#MACHO', 'ADORN#INLET', 'MIRED#STILT', 'BETA#TRIFLE', 'AUSTERE#FOR', '####VIA####', 'ASS#ABDOMEN', 'DECIDE#ROLE', 'AGATE#ADOBE', 'PURER#RESOD', 'TEEMS#CREWS'],
    title: 'Plain and Simple',
    clues: {
        '1A': 'Without a gloss',
        '6A': 'Tough-guy in manner',
        '11A': 'Dress up with trimmings',
        '12A': 'Narrow bay where the sea reaches the land',
        '13A': 'Stuck in the mud',
        '14A': 'One of a circus walker\'s tall poles',
        '15A': 'The second Greek letter',
        '16A': 'A small matter; an English dessert',
        '17A': 'Plain and severe',
        '19A': '"Hope ___ the best"',
        '20A': 'By way of; passing through',
        '21A': 'A donkey',
        '24A': 'The midsection',
        '29A': 'Make up your mind',
        '31A': 'An actor\'s part',
        '32A': 'Hard stone, like striped quartz',
        '33A': 'Sun-dried mud brick used in Southwest homes',
        '34A': 'Less mixed',
        '35A': 'Lay fresh turf',
        '36A': 'Overflows (with)',
        '37A': 'Ships\' companies',
        '1D': 'A fast African snake',
        '2D': 'A fond farewell',
        '3D': 'Cases in a civil courtroom',
        '4D': 'A small gift, or a special snack for a dog',
        '5D': 'The very last bit',
        '6D': 'Got the wrong idea from',
        '7D': 'Against (prefix)',
        '8D': 'A sheer rock face',
        '9D': 'A friendly greeting',
        '10D': 'Furry animal that floats on its back and cracks shells',
        '16D': 'A family or a folk grouping',
        '18D': 'Those who duck the question',
        '21D': 'The very heart of the matter',
        '22D': 'Smooth move from one song to the next',
        '23D': 'Give a fright',
        '25D': 'Tidy lineup, or a restaurant request',
        '26D': 'Large antlered animal of the north woods',
        '27D': 'The joint in the middle of your arm',
        '28D': 'Must-haves',
        '30D': 'One thing on the list',
        '33D': 'Part of a circle\'s curve',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0060 — "Dry Wit" (18 blocks)
const FULL_0060 = buildPuzzle({
    id: 'full-0060',
    size: 'full',
    difficulty: 'hard',
    layout: ['OPTED#ANGST', 'CRANE#DOLCE', 'TONGS#SWOON', 'ANKLES##BUT', 'DESIRE#SETS', '###START###', 'DASH#TOASTS', 'OUT##SATIRE', 'GRADE#RUNIC', 'MANIA#ERECT', 'ALDER#DESKS'],
    title: 'Dry Wit',
    clues: {
        '1A': 'Chose, as from a menu',
        '6A': 'A load of worry',
        '11A': 'Long-armed machine on a building site',
        '12A': 'Sweetly, on a music score',
        '13A': 'Grabbers for the salad bowl',
        '14A': 'Faint from delight',
        '15A': 'What high-tops support',
        '17A': '\'Slow ___ steady wins the race\'',
        '18A': 'A deep wish',
        '19A': 'Places where you sit, as in a theater',
        '20A': 'Get going',
        '22A': 'A quick dart from one spot to another',
        '25A': 'Raises a glass; browns the bread',
        '29A': 'Not in, but ___',
        '30A': 'Wit with a sharp edge',
        '31A': 'A school mark like A, B, or C',
        '34A': 'Like old Norse writing',
        '35A': 'A wild craze or obsession',
        '36A': 'Build standing upright',
        '37A': 'Streamside tree of the birch family',
        '38A': 'Where the schoolwork gets done',
        '1D': 'A group of eight',
        '2D': 'Lying face down; inclined (to)',
        '3D': 'Where goldfish circle',
        '4D': 'The language of Shakespeare',
        '5D': 'The Sahara, famously',
        '6D': 'Notices in the newspaper selling things, for short',
        '7D': 'This very moment',
        '8D': 'The world on a stand',
        '9D': 'One out looking ahead',
        '10D': 'Canvas shelters used for camping',
        '16D': 'Chairs in a theater or on a bus',
        '19D': 'Standing and height',
        '21D': 'Thundered like a lion',
        '22D': 'Doctrine not open to question',
        '23D': 'Of the ear',
        '24D': 'Rise to your feet; a lemonade seller\'s spot',
        '26D': 'Ratios from trigonometry class',
        '27D': 'A bit of sleight of hand',
        '28D': 'Branches of a faith',
        '32D': 'One of a pair of dice',
        '33D': 'Part of the head used for listening',
    },
    attribution: FULL_ATTRIBUTION,
});
// full-0061 — "Ever Fonder" (18 blocks)
const FULL_0061 = buildPuzzle({
    id: 'full-0061',
    size: 'full',
    difficulty: 'hard',
    layout: ['STAY##METRO', 'TACOS#UNWED', 'ABOUT#STAND', 'FOR#ETERNAL', 'FONDER#UGLY', '###ALIAS###', 'PASS#ALTARS', 'ASPHALT#BUT', 'STREW#ELOPE', 'TIARA#RIVER', 'ARTSY##TEEN'],
    title: 'Ever Fonder',
    clues: {
        '1A': 'Remain put',
        '5A': 'City train that runs underground',
        '10A': 'Crisp-folded Mexican fare',
        '12A': 'Not yet married',
        '13A': 'Roughly; "___ ten o\'clock"',
        '14A': 'Rise to your feet; a lemonade seller\'s spot',
        '15A': '"Just ___ instance..."',
        '16A': 'Without end',
        '18A': 'What absence makes the heart grow',
        '20A': 'Not pretty to look at',
        '21A': 'A false name someone goes by',
        '23A': 'Hand along the potatoes',
        '26A': 'Where wedding vows are said',
        '30A': 'What fresh-paved roads are made of',
        '32A': 'Word joining two opposing ideas',
        '33A': 'Scatter about',
        '34A': 'Skip the big wedding',
        '36A': 'Sparkling crown for a queen',
        '37A': 'Flowing water like the Mississippi or Nile',
        '38A': 'Given to berets and galleries',
        '39A': 'Thirteen to nineteen years old',
        '1D': 'The workers, collectively',
        '2D': 'Something forbidden by custom',
        '3D': 'The oak\'s little starter kit',
        '4D': 'The person being spoken to',
        '5D': 'Ponder dreamily; a poet\'s inspiration',
        '6D': 'Place in safe hands',
        '7D': 'The sound of a plucked banjo string',
        '8D': 'Having to do with the kidneys',
        '9D': 'Strangely enough',
        '11D': 'Strong metal made from iron and carbon',
        '17D': 'A test or hardship to get through',
        '19D': 'Sprinters off the starting line',
        '22D': 'Change to suit, as a hem',
        '23D': 'Italian noodles served with sauce',
        '24D': 'Up and moving about',
        '25D': 'Small herring-like fish',
        '27D': 'Overhead',
        '28D': 'Indian coin worth a hundred paise',
        '29D': 'Toward the back of a ship',
        '31D': 'Far off in the distance',
        '35D': 'Brightly burning, as a candle',
    },
    attribution: FULL_ATTRIBUTION,
});
export const FULL_PUZZLES = [
    FULL_0001,
    FULL_0002,
    FULL_0003,
    FULL_0004,
    FULL_0005,
    FULL_0006,
    FULL_0007,
    FULL_0008,
    FULL_0009,
    FULL_0010,
    FULL_0011,
    FULL_0012,
    FULL_0013,
    FULL_0014,
    FULL_0015,
    FULL_0016,
    FULL_0017,
    FULL_0018,
    FULL_0019,
    FULL_0020,
    FULL_0021,
    FULL_0022,
    FULL_0023,
    FULL_0024,
    FULL_0025,
    FULL_0026,
    FULL_0027,
    FULL_0028,
    FULL_0029,
    FULL_0030,
    FULL_0031,
    FULL_0032,
    FULL_0033,
    FULL_0034,
    FULL_0035,
    FULL_0036,
    FULL_0037,
    FULL_0038,
    FULL_0039,
    FULL_0040,
    FULL_0041,
    FULL_0042,
    FULL_0043,
    FULL_0044,
    FULL_0045,
    FULL_0046,
    FULL_0047,
    FULL_0048,
    FULL_0049,
    FULL_0050,
    FULL_0051,
    FULL_0052,
    FULL_0053,
    FULL_0054,
    FULL_0055,
    FULL_0056,
    FULL_0057,
    FULL_0058,
    FULL_0059,
    FULL_0060,
    FULL_0061,
];
//# sourceMappingURL=full.js.map